var graph_lib =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(25);
	__webpack_require__(16);
	__webpack_require__(17);
	__webpack_require__(22);
	__webpack_require__(18);
	__webpack_require__(21);
	__webpack_require__(19);
	__webpack_require__(20);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Just this class and friends
	 * @module sample-graph
	 */
	/**
	* Sample Graph
	*
	* A graphing engine that aims to plot sampled data.
	*
	* Features:
	*   - Time-based or simple numeric x-axis
	*   - Label points and sections TODO
	*   - Linear interpolation TODO
	*
	* Design decisions:
	*   - All pixel coordinates passed to functions are relative to the
	* canvas origin. The plot probably has a margin.
	*
	* What's a pointsAround object? {closestI, lowI, highI, pct}
	* lets say we have this:
	*   4---------5------x--6---------7
	*   lowI: 5, highI: 6, closestI: 6, pct: 0.8
	*
	* @class SampleGraph
	*/
	/** @namespace SampleGraph */
	(function () {
	  // SampleGraph constructor
	  // Required options: canvasId, data
	  var SG = function SG(opts) {
	    _.bindAll(this, 'zoomOutOnClick', 'zoomToDataSlice');
	    this.setupGlobalEvents();
	
	    // Configure graph from options
	    this.canvasId = opts.canvasId;
	    this.uniqueClass = opts.canvasId + '_sg';
	    this.$canvas = $('#' + this.canvasId);
	    this.canvas = this.$canvas.get(0);
	    this.ctx = document.getElementById(this.canvasId).getContext("2d");
	    this.$canvas.addClass('sample-graph');
	    this.options = _.clone(SG.defaultOptions);
	    this.trigger('configure');
	    _.extend(this.options, opts);
	    this.data(opts.data || []);
	    this._xAxisType = opts.xAxisType || 'distance';
	    this.metricsEnabled([]);
	    this.nearestPixel = false;
	
	    // maybe this should be per metric since it may only need to apply
	    // to ele
	    this.minPaddingPct = 0.05;
	
	    this.defaultStrokeStyle = 'black';
	    this.defaultFillStyle = 'black';
	
	    this.setInitialCanvasState();
	
	    // setting padding for plot region
	    this.plotMargin({
	      top: 7
	    });
	
	    this.trigger('initialize:after');
	    this.render();
	  };
	
	  // allow setting / triggering of events for all instances
	  _.extend(SG, Backbone.Events);
	
	  _.extend(SG.prototype, Backbone.Events, {
	    bindTo: function bindTo(target, ev, callback) {
	      target.bind(ev, callback);
	      var calls = this._externalBindings || (this._externalBindings = {});
	      var list = calls[ev] || (calls[ev] = []);
	      list.push([target, callback]);
	    },
	    unbindFrom: function unbindFrom(target, ev, callback) {
	      target.unbind(ev, callback);
	      var calls = this._externalBindings;
	      if (!calls) return this;
	      var list = calls[ev];
	      if (!list) return this;
	      for (var i = 0, l = list.length; i < l; i++) {
	        if (list[i] && target === list[i][0] && callback === list[i][1]) {
	          list[i] = null;
	          break;
	        }
	      }
	    },
	    unloadBindings: function unloadBindings() {
	      this.trigger('unload_bindings:before');
	      _.each(this._externalBindings, function (list, ev) {
	        _.each(list, function (arr) {
	          if (arr) arr[0].unbind(ev, arr[1]);
	        });
	      });
	      this._externalBindings = {};
	    },
	    /**
	    * Set a graph option. Does not re-render or anything, just sets the option. Check out SampleGraph.defaultOptions to see them all.
	    * @method set
	    * @param {String | Object} key As a string, specifies the property to set. Otherwise, expects an object with property/value pairs for mass assignment.
	    * @param {MIXED} val (optional, only use if passing a single string key) The value to assign
	    */
	    set: function set(key, val) {
	      if (key && val) {
	        this.options[key] = val;
	      } else {
	        // only 1 param, expected to be an object with multiple properties to set
	        _.extend(this.options, key);
	      }
	    },
	    /**
	    * Get a graph option.
	    * @method get
	    * @param {String} key The property to get
	    * @return {MIXED} The value associated with the specified property
	    */
	    get: function get(key) {
	      return this.options[key];
	    },
	
	    // allow binding to events triggered from any instance
	    // used for hooking into initialize:after by plugins
	    setupGlobalEvents: function setupGlobalEvents() {
	      this.bind('all', function () {
	        var argsWithoutEv = Array.prototype.slice.call(arguments, 1);
	        SG.trigger.apply(SG, [arguments[0], this].concat(argsWithoutEv));
	      }, this);
	    },
	
	    // it will be ele if its enabled, because thats how its sorted
	    primaryMetric: function primaryMetric() {
	      var metricsEnabled = this.metricsEnabled();
	      if (metricsEnabled.length === 0) return;
	      return this.metrics(metricsEnabled[0]);
	    },
	
	    // setter/getter for x-axis type
	    // typical values: "time" or "distance"
	    // also valid: a key referencing a monotonically increasing value that exists on all data points
	    xAxisType: function xAxisType(str) {
	      if (str && str != this._xAxisType) {
	        this._xAxisType = str;
	        this.trigger('xAxisType:change');
	      }
	      return this._xAxisType;
	    },
	
	    strokeStyle: function strokeStyle(metric) {
	      return this.options.strokes[metric];
	    },
	
	    fillStyle: function fillStyle(metric) {
	      if (metric === 'unpaved') {
	        return this.surfacePattern();
	      }
	      return this.options.fills[metric];
	    },
	
	    // setter / getter for plot margins - keys are top bottom left right
	    // updates plotWidth and plotHeight
	    plotMargin: function plotMargin(margin) {
	      if (margin) {
	        if (!this._plotMargin) this._plotMargin = { top: 0, right: 0, bottom: 0, left: 0 };
	        _.extend(this._plotMargin, margin);
	        this.plotWidth = this.width() - 1 - this._plotMargin.left - this._plotMargin.right;
	        this.plotHeight = this.height() - 1 - this._plotMargin.top - this._plotMargin.bottom;
	      }
	      return this._plotMargin;
	    },
	
	    // overall width
	    width: function width() {
	      return this.$canvas.width();
	    },
	
	    // overall height
	    height: function height() {
	      return this.$canvas.height();
	    },
	
	    showSurface: function showSurface(bool) {
	      if (bool !== undefined) {
	        this._showSurface = bool;
	        return;
	      }
	      if (this._showSurface === undefined) {
	        var val = this.options.showSurface;
	        if (val === undefined) {
	          val = Routes.activeMap && Routes.activeMap.activeRoute.showSurface;
	        }
	        if (val === undefined) {
	          this.options.segmentSelectorMode === 'planner' || this.metricsCalculator().hasSurface();
	        }
	        this._showSurface = val;
	      }
	      return this._showSurface;
	    },
	
	    toggleShowSurface: function toggleShowSurface() {
	      this.showSurface(!this.showSurface());
	    },
	
	    // resize the canvas and re-render the graph
	    resize: function resize(w, h) {
	      if (!w) w = this.$canvas.parent().width();
	      if (!h) h = this.$canvas.parent().height();
	      this.canvas.width = w;
	      var sgBarHeight = this.options.plotOnly ? 0 : $('.sg-bar').height() || 25; // default to 25px if it's not loaded yet, happens in routes/embed
	      this.canvas.height = h - sgBarHeight;
	      this.$canvas.offset({ top: this.$canvas.parent().offset().top + $('.sg-bar').height() });
	      // after changing width and height it resets the canvas
	      this.setInitialCanvasState();
	      this.render(true);
	      this.trigger('resize');
	    },
	
	    setInitialCanvasState: function setInitialCanvasState() {
	      this.ctx.translate(0.5, 0.5);
	      this.ctx.strokeStyle = this.defaultStrokeStyle;
	      this.ctx.fillStyle = this.defaultFillStyle;
	      this.ctx.save();
	    },
	
	    // are we zoomed in?
	    zoomedIn: function zoomedIn() {
	      return !!this.zoomedSlice();
	    },
	
	    zoomedSlice: function zoomedSlice(dataSlice, globalNotificationDone) {
	      if (dataSlice) {
	        if (SG.globalOptions.globalZoom) {
	          // make sure this is only bound once, so unbind if its been done
	          this.unbindFrom(this, 'pointselected', this.zoomOutOnClick);
	          this.bindTo(this, 'pointselected', this.zoomOutOnClick);
	          // dont propogate this change out globally if it has already
	          // been done
	          if (!globalNotificationDone) {
	            this._data._zoomedSlice = dataSlice;
	            this.unbindFrom(this._data, 'zoom:in', this.zoomToDataSlice);
	            this._data.trigger('zoom:in', dataSlice, true);
	            this.bindTo(this._data, 'zoom:in', this.zoomToDataSlice);
	          }
	        } else {
	          if (!this._zoomedSlice) // only need to bind this if we're not already zoomed in
	            this.bindTo(this, 'pointselected', this.zoomOutOnClick);
	          this._zoomedSlice = dataSlice;
	        }
	      }
	      return SG.globalOptions.globalZoom ? this._data._zoomedSlice : this._zoomedSlice;
	    },
	
	    // keep track of the zoomed slice and render
	    zoomToDataSlice: function zoomToDataSlice(dataSlice, globalNotificationDone) {
	      this.zoomedSlice(dataSlice, globalNotificationDone);
	      this.trigger('zoom:in', dataSlice);
	      this.render();
	    },
	
	    // zoom out and unbind this listener
	    zoomOutOnClick: function zoomOutOnClick(pointsAround, globalNotificationDone) {
	      this.zoomOut(globalNotificationDone);
	      this.unbindFrom(this, 'pointselected', this.zoomOutOnClick);
	    },
	
	    zoomOut: function zoomOut(globalNotificationDone) {
	      if (SG.globalOptions.globalZoom && !globalNotificationDone) {
	        delete this._data._zoomedSlice;
	        this.unbindFrom(this._data, 'zoom:out', this.zoomOutOnClick);
	        this._data.trigger('zoom:out', null, true);
	        this.bindTo(this._data, 'zoom:out', this.zoomOutOnClick);
	      } else if (this._zoomedSlice) {
	        delete this._zoomedSlice;
	      }
	      this.trigger('zoom:out');
	      this.render();
	    },
	
	    // choose which metrics to graph and re-render
	    // typical: ['ele', 'hr'] or ['watts']
	    // valid: array of keys that exists on any (not necessarily on all) data points
	    metricsEnabled: function metricsEnabled(metrics) {
	      if (metrics) {
	        if (!this.plotMetaData) this.plotMetaData = { time: {}, distance: {} };
	        _.each(metrics, function (metric) {
	          if (!this.plotMetaData[metric]) this.plotMetaData[metric] = {};
	        }, this);
	        if (metrics.length > 0 && this.showSurface() && this._metricsEnabled.indexOf('surfaces') === -1) {
	          // surface is a fake metric, so we have to add it manually
	          metrics.push('surfaces');
	        }
	        var sortBy = {
	          ele: 1,
	          surfaces: 2,
	          cad: 3,
	          hr: 4,
	          speed: 5,
	          watts: 6,
	          grade: 7
	        };
	        this._metricsEnabled = _.sortBy(metrics, function (x) {
	          return sortBy[x];
	        });
	        // metricsEnabled changed so blow the metricVariationInUse cache
	        this._metricVariationInUse = {};
	      }
	      return this._metricsEnabled;
	    },
	
	    // hand back the base metric unless a computed version is in
	    // metricsEnabled
	    metricVariationInUse: function metricVariationInUse(baseMetricKey) {
	      // we cache this value until metricsEnabled changes, at which
	      // time metricsEnabled will blow the cached val
	      if (this._metricVariationInUse[baseMetricKey]) return this._metricVariationInUse[baseMetricKey];
	
	      // loop through enabled, if one of them is a computed variation,
	      // return that key. otherwise hand back the baseMetricKey
	      var computedKey = _.find(this.metricsEnabled(), function (key) {
	        return this.metrics(key).isComputed() && this.metrics(key).baseMetricKey() == baseMetricKey;
	      }, this);
	      return computedKey || baseMetricKey;
	    },
	
	    // what's a pointsAround object?
	    // lets say we have this:
	    //   4---------5------x--6---------7
	    //   lowI: 5, highI: 6, closestI: 6, pct: 0.8
	    pointsAroundToX: function pointsAroundToX(pointsAround) {
	      var data = this.data(),
	          xAxisType = this.xAxisType();
	      if (pointsAround.highI > data.length - 1) return; // out of bounds
	      // first scale based on pct to get the interpolated x value
	      var delta = data[pointsAround.highI][xAxisType] - data[pointsAround.lowI][xAxisType];
	      var interpolatedValue = data[pointsAround.lowI][xAxisType] + delta * pointsAround.pct;
	      return this.plotToPixel(interpolatedValue);
	    },
	
	    // type can by pixel, time, or distance
	    pointsAroundX: function pointsAroundX(x, type) {
	      var data = this.dataToRender(),
	          ptOffset,
	          ptsAround;
	      if (this.zoomedIn()) ptOffset = this.zoomedSlice().i;
	
	      if (type == 'pixel') {
	        ptsAround = this._data.pointsAroundX(this.pixelToPlot(x), this.xAxisType(), data, ptOffset);
	        ptsAround.x = x;
	      } else {
	        ptsAround = this._data.pointsAroundX(x, type, data, ptOffset);
	      }
	      return ptsAround;
	    },
	
	    // given a canvas x coord, get the index of the nearest point
	    canvasXToDataI: function canvasXToDataI(x) {
	      return this.pointsAroundX(x, 'pixel');
	    },
	
	    // pass a pixel, get back a scaled plot value
	    // passing x or y alone will get a number back. passing both will get an object back with x and y properties
	    pixelToPlot: function pixelToPlot(x, y, metric) {
	      var plotX, plotY;
	      if (x) {
	        x -= this._plotMargin.left;
	        plotX = x / this.xRatio + this.xMin;
	      }
	      if (y) {
	        y = this.plotHeight - (y - this._plotMargin.top);
	        plotY = y / this.plotMetaData[metric].ratio + this.plotMetaData[metric].min;
	      }
	      if (!_.isNumber(x)) return plotY;
	      if (!_.isNumber(y)) return plotX;
	      return { x: plotX, y: plotY };
	    },
	
	    plotToPixel: function plotToPixel(x, y, metric) {
	      var pixelX,
	          pixelY,
	          round = this.nearestPixel;
	      if (x || x == 0) {
	        pixelX = (x - this.xMin) * this.xRatio + this._plotMargin.left;
	        if (round) pixelX = Math.round(pixelX);
	      }
	      if (y || y == 0) {
	        pixelY = this.plotHeight - (y - this.plotMetaData[metric].min) * this.plotMetaData[metric].ratio + this._plotMargin.top;
	        if (round) pixelY = Math.round(pixelY);
	      }
	      if (isNaN(pixelX)) pixelX = 0;
	      if (isNaN(pixelY)) pixelY = 0;
	      if (!x && x != 0) return pixelY;
	      if (!y && y != 0) return pixelX;
	      return { x: pixelX, y: pixelY };
	    },
	
	    /**
	     * Setter/getter for the data used by this graph. When used as a setter fires data:change event. Also binds to points:change on the Data instance, and fires a data:change event in response.
	     * @param {rwgps.Data | Array} data If a SampleGraph.Data instance is provided, just uses that. If an Array is provided, creates a SampleGraph.Data instance from it.
	     * @return {Array} The points only - not the rwgps.Data instance.
	     */
	    data: function data(_data) {
	      if (_data) {
	        var alreadyBoundToEvents = false;
	        if (this._data && this._data === _data) alreadyBoundToEvents = true;
	
	        if (_data.points && _data.metricsCalculator) {
	          // looks like an instance of rwgps.Data
	          this._data = _data;
	          // lets see if its already zoomed in, if so we gotta track this ourselves and bind a handler for zoom out
	          if (_data._zoomedSlice) {
	            this.zoomedSlice(_data._zoomedSlice, true);
	            this.trigger('zoom:in', _data._zoomedSlice);
	          }
	        } else {
	          if (this._data) this._data.points(_data);else this._data = new rwgps.Data(_data);
	        }
	        var metricsX = this.metricsX();
	        if (metricsX.length == 1 && metricsX[0].key() != this.xAxisType()) {
	          this.xAxisType(metricsX[0].key());
	        }
	        if (!alreadyBoundToEvents) {
	          // in case we're using globalZoom, we'll need to be bound to
	          // the zoom events
	          this.bindTo(this._data, 'zoom:out', this.zoomOutOnClick);
	          this.bindTo(this._data, 'zoom:in', this.zoomToDataSlice);
	          // if the Data instance changes underneath us... forward those events along!
	          this.bindTo(this._data, 'points:change', function () {
	            this.trigger('data:change');
	          }, this);
	        }
	        // data changed, so update metrics
	        this.resetMetrics();
	        // need to trigger a change event right now as well.
	        this.trigger('data:change');
	      }
	
	      return this._data.points();
	    },
	
	    resetMetrics: function resetMetrics() {
	      delete this._metrics;
	      var metricsEnabled = _.filter(this.metricsEnabled(), function (key) {
	        return this.metrics(key);
	      }, this);
	      if (metricsEnabled.length === 0) {
	        if (this.metrics('ele')) {
	          metricsEnabled.push('ele');
	          if (this.options.segmentSelectorMode === 'planner' || this.showSurface()) {
	            metricsEnabled.push('surfaces');
	          }
	        } else if (this.metricsY().length > 0) {
	          if (this.metricsY()[0].key() !== 'surfaces') {
	            // don't ever want an initial render with metricsEnabled === ['surfaces']
	            metricsEnabled.push(this.metricsY()[0].key());
	          }
	        }
	      }
	      this.metricsEnabled(metricsEnabled);
	
	      // make sure xaxis is still available, otherwise use what is
	      if (!this.metrics(this.xAxisType())) {
	        if (this.metricsX().length > 0) this.xAxisType(this.metricsX()[0].key());
	      }
	    },
	
	    // if we're zooming in, and we've got a selection, render that. otherwise grab all data
	    dataToRender: function dataToRender() {
	      if (this.zoomedIn()) {
	        return this.zoomedSlice().points();
	      } else {
	        return this.data();
	      }
	    },
	    /**
	     * Delegates to our instance of Data.
	     * @return {rwgps.MetricsCalculator} Current metrics calculator
	     */
	    metricsCalculator: function metricsCalculator() {
	      return this._data.metricsCalculator();
	    },
	
	    // this method name is long...
	    metricsCalculatorForDataToRender: function metricsCalculatorForDataToRender() {
	      if (this.zoomedIn()) {
	        return this.zoomedSlice().metricsCalculator();
	      } else {
	        return this.metricsCalculator();
	      }
	    },
	
	    // includes computed variations
	    metricsKeys: function metricsKeys() {
	      return _.map(this.metricsWithComputed(), function (m) {
	        return m.key();
	      });
	    },
	
	    metricsY: function metricsY() {
	      return _.filter(this.metrics(), function (m) {
	        return m.axis() == 'y';
	      });
	    },
	
	    metricsX: function metricsX() {
	      return _.filter(this.metrics(), function (m) {
	        return m.axis() == 'x';
	      });
	    },
	
	    metricsKeysY: function metricsKeysY() {
	      return _.map(this.metricsY(), function (m) {
	        return m.key();
	      });
	    },
	
	    metricsWithComputed: function metricsWithComputed() {
	      return this.metrics('all');
	    },
	
	    // allows special key "all" to include computed
	    metrics: function metrics(key) {
	      var mc = this.metricsCalculatorForDataToRender();
	      if (!this._metrics || this._metrics.length <= 1) {
	        // figure all this stuff out again because our _cachedMC is old
	        var mcMetrics = this._cachedMC = mc.enabledMetrics();
	        // we can be smart in here, and know that watts_30 means a 30
	        // second moving average of watts
	        var metricsByKey = {};
	        for (var i = 0; i < mcMetrics.length; i++) {
	          if (mcMetrics[i].indexOf('_') != -1) {
	            // its a computed metric, based on a measured one
	            var arr = mcMetrics[i].split('_');
	            var baseMetric = arr[0],
	                computedType = arr[1],
	                variant = arr[2];
	            if (!metricsByKey[baseMetric]) metricsByKey[baseMetric] = this.createMetric(baseMetric);
	            var computed = this.createMetric(mcMetrics[i], {
	              type: computedType,
	              variant: variant
	            });
	            metricsByKey[baseMetric].addComputed(computed);
	            metricsByKey[computed.key()] = computed;
	          } else {
	            // regular ol metric
	            if (!metricsByKey[mcMetrics[i]]) metricsByKey[mcMetrics[i]] = this.createMetric(mcMetrics[i]);
	          }
	        }
	        // add the x-axis metrics
	        if (mc.hasDistance()) {
	          metricsByKey.distance = this.createMetric('distance', { axis: 'x' });
	        }
	        if (mc.hasTime()) {
	          metricsByKey.time = this.createMetric('time', { axis: 'x' });
	        }
	        this._metricsWithComputed = _.map(metricsByKey, function (m) {
	          return m;
	        });
	        this._metrics = _.filter(this._metricsWithComputed, function (m) {
	          return !m.isComputed();
	        });
	        this._metricsByKey = metricsByKey;
	      }
	      // if they specified a key, give them that metric
	      if (key == 'all') return this._metricsWithComputed;else if (key) return this._metricsByKey[key];
	      // otherwise give them the array
	      return this._metrics || [];
	    },
	
	    // make sure we have all the data we need to render, such as
	    // mins/maxes, axis labels, etc
	    // all the stuff that needs to be ready before drawing can happen
	    preRender: function preRender() {
	      var data = this.dataToRender();
	      // make sure we have data summaries ready
	      var metricsCalculator = this.metricsCalculatorForDataToRender();
	      var metrics = this.metricsEnabled();
	      while (metrics.indexOf('surfaces') >= 0) {
	        // disregard 'surfaces' for purposes of plot dimension calculations
	        metrics.remove(metrics.indexOf('surfaces'), 1);
	      }
	      // we'll alternate sides for each y-axis, left/right/left/right
	      // with that in mind... compute space needed and set padding
	      this.yAxisWidth = 40;
	      this.plotMargin({
	        left: Math.ceil(metrics.length / 2) * this.yAxisWidth,
	        right: Math.max(10, Math.floor(metrics.length / 2) * this.yAxisWidth),
	        bottom: this.xAxisOuterHeight()
	      });
	
	      // helper function to compute all the values we need for our plotMetaData
	      // these are: the plot min/max, the pixel to plotval ratio, the nice tick values, and
	      // the nfrac (number of fractional decimals to show in tick labels)
	      var setupPlotMetaData = _.bind(function (metricKey, min, max, ntick, tightMin, tightMax) {
	        // if max and min are same, need to spread them out so we can
	        // draw a y-axis
	        if (max == min) {
	          max += 1;
	          min -= 1;
	        }
	        // require a minimum range difference of 45 meters for ele graph
	        // otherwise a mostly flat ride can look like you're crossing the alps
	        if (metricKey == 'ele' && !this.zoomedIn() && max - min < 45) {
	          max += 45 - (max - min);
	        }
	        var metric = this.metrics(metricKey),
	            looseLabels = SG.looseLabels(metric.convert(min), metric.convert(max), ntick),
	            numTicks = looseLabels.tickValues.length,
	            looseMin = metric.inverseConvert(looseLabels.tickValues[0]),
	            looseMax = metric.inverseConvert(looseLabels.tickValues[numTicks - 1]),
	            tickSliceStart,
	            tickSliceEnd,
	            pmd = this.plotMetaData[metricKey];
	        if (tightMin) {
	          pmd.min = min;
	          tickSliceStart = 1;
	        } else {
	          pmd.min = looseMin;
	          tickSliceStart = 0;
	        }
	        if (tightMax) {
	          pmd.max = max;
	          tickSliceEnd = numTicks - 1;
	        } else {
	          pmd.max = looseMax;
	          tickSliceEnd = numTicks;
	        }
	
	        pmd.tickValues = looseLabels.tickValues.slice(tickSliceStart, tickSliceEnd);
	        pmd.nfrac = looseLabels.nfrac;
	        pmd.ratio = this.plotHeight / (pmd.max - pmd.min);
	      }, this);
	
	      // now just run through each metric and use our plotMetaData helper
	      var idealYTickNum = Math.round(this.plotHeight / 20);
	      for (var i = 0; i < metrics.length; i++) {
	        var metric = metrics[i],
	            max = metricsCalculator.getMetric(metric, '_max'),
	            min = metricsCalculator.getMetric(metric, '_min'),
	            paddedMin = min - 0.05 * (max - min);
	        setupPlotMetaData(metric, metric == 'ele' ? paddedMin : min, max, idealYTickNum, metric == 'ele', false);
	      }
	
	      // and set the plotMetaData for whatever our x-axis is
	      var xAxisType = this.xAxisType();
	
	      setupPlotMetaData(xAxisType, data[0][xAxisType], // min
	      data[data.length - 1][xAxisType], // max
	      Math.floor(this.plotWidth / 60), // ideal # of x-ticks
	      true, // tight min
	      true); // tight max
	    },
	
	    /**
	     * Standard rendering routing.
	     */
	    render: function render(force) {
	      if (this.dataToRender().length < 2) return; // we must graph at least 2 points!
	      if (force) {
	        this.synchronousRender();
	      } else {
	        var that = this;
	        if (this._renderId) {
	          cancelAnimationFrame(this._renderId);
	        }
	        this._renderId = requestAnimationFrame(function () {
	          that.synchronousRender();
	        });
	      }
	    },
	
	    clearAll: function clearAll() {
	      this.clearBeforeRender();
	      $('.' + this.uniqueClass).remove();
	    },
	
	    /**
	     * Once unload is ran, this will be set to true. Asynchronous rendering routines will respect the unloaded state and abort if the graph was unloaded before they had a chance to run.
	     * @property unloaded
	     * @default false
	     */
	    unloaded: false,
	
	    /**
	     * A destructor for the graph. Remove all DOM elements and unbind all event handlers.
	     */
	    unload: function unload() {
	      this.unloaded = true;
	      this.unloadBindings();
	      this.clearAll();
	    },
	
	    // clear canvas and redraw all axis and plots
	    synchronousRender: function synchronousRender() {
	      if (this.unloaded) return;
	
	      this.clearBeforeRender();
	      if (this.dataToRender().length === 0) return;
	
	      this.preRender();
	      var metrics = this.metricsEnabled();
	      var plotMargin = this.plotMargin();
	      for (var i = 0; i < metrics.length; i++) {
	        var onLeft = i % 2 == 0;
	        var yaxisoffset = onLeft ? plotMargin.left - this.yAxisWidth - i / 2 * this.yAxisWidth : this.width() - (plotMargin.right - (i + 1) / 2 * this.yAxisWidth + this.yAxisWidth);
	        this.drawYAxis(metrics[i], yaxisoffset);
	        this.drawPlot(metrics[i]);
	        // its cool to draw a line at 0 grade if grade is plotted... might be neat to be smarter about where this code is but ... refactor as you go i guess
	        if (metrics[i] == 'grade') {
	          this.drawHorizontalLine(this.plotToPixel(null, 0, 'grade'), this.strokeStyle('grade'));
	        }
	      }
	      this.drawXAxis();
	      this.trigger('reflow');
	      this.trigger('render:after');
	    },
	
	    xAxisConfig: function xAxisConfig() {
	      if (!this._xAxisConfig) this._xAxisConfig = _.extend({}, SG.defaultXAxisConfig);
	      return this._xAxisConfig;
	    },
	
	    xAxisOuterHeight: function xAxisOuterHeight() {
	      var conf = this.xAxisConfig();
	      return conf.lineSideMargin + conf.innerTicksLength + conf.tickLabelMargin + conf.tickLabelTextHeight + conf.axisLabelMargin + conf.axisLabelTextHeight;
	    },
	
	    // used for filtering out data
	    // e.g. filters[cad] = function(x) { return x > 10 }
	    filters: function filters(_filters) {
	      if (!this._filters) this._filters = {};
	      if (_filters) _.extend(this._filters, _filters);
	      return this._filters;
	    },
	
	    // grab a zIndex. things appear at different layers, and we want increasing zIndexes at a given layer each time this is called.
	    zIndex: function zIndex(level) {
	      if (!this._nextZIndex) {
	        this._nextZIndex = 2000;
	      }
	      return this._nextZIndex++ + (level ? level * 1000 : 0);
	    },
	
	    formatNumber: function formatNumber(x, metric, increasePrecision) {
	      if (metric == 'time') {
	        if (this.plotMetaData[metric].nfrac > 0 || increasePrecision) {
	          // we need to display seconds, so just use the hh:mm:ss format
	          return rwgps.LabelMaker.durationLabel(Math.round(x * 60));
	        } else {
	          // no need to show seconds so use the xhym format
	          return rwgps.LabelMaker.durationLabel(Math.round(x * 60), true);
	        }
	      } else {
	        var nfrac = this.plotMetaData[metric].nfrac;
	        if (increasePrecision) nfrac += 1;
	        if (nfrac == 0 && x > 990 && rwgps.site != 'gi') {
	          return Math.round(x * 0.01) / 10 + 'k';
	        } else {
	          return x.toFixed(nfrac);
	        }
	      }
	    },
	
	    dataSlice: function dataSlice(i, count) {
	      return new rwgps.DataSlice(this, i, count);
	    },
	
	    createMetric: function createMetric(key, opts) {
	      return new SG.Metric(this, key, opts);
	    },
	
	    partitionByDistanceFraction: function partitionByDistanceFraction(frac) {
	      this.partition(this._data.partitionByDistanceFraction(frac));
	    },
	    partition: function partition(_partition) {
	      if (_partition !== undefined) {
	        if (this.zoomedIn()) this.zoomOutOnClick();
	        this._partition = _partition;
	        this.trigger('partition:change', _partition);
	      }
	      return this._partition;
	    },
	    surfacePattern: function surfacePattern() {
	      return this.ctx.createPattern(this.unpavedPattern(), 'repeat');
	    }
	  });
	
	  SG.niceNum = function (x, round) {
	    var exp, f, nf;
	    exp = Math.floor(Math.log(x) / Math.LN10);
	    f = x / Math.pow(10, exp);
	    if (round) {
	      if (f < 1.5) nf = 1;else if (f < 3) nf = 2;else if (f < 7) nf = 5;else nf = 10;
	    } else {
	      if (f <= 1) nf = 1;else if (f <= 2) nf = 2;else if (f <= 5) nf = 5;else nf = 10;
	    }
	    return nf * Math.pow(10, exp);
	  };
	
	  SG.looseLabels = function (min, max, ntick) {
	    var labelsAt = [],
	        nfrac,
	        d,
	        graphmin,
	        graphmax,
	        range,
	        x;
	    // prevent non-zero values from hitting the graph bottom, otherwise looks like dropouts
	    if (min != 0) {
	      var newmin = min - (max - min) * 0.005;
	      // if our actual min is greater than 0, and the padded min ends up dropping below 0, just set it as 0
	      // it's most likely something that has a natural min of 0 and just drops low (speed, cad, watts, etc)
	      if (min > 0 && newmin < 0) min = 0;else min = newmin;
	    }
	    range = SG.niceNum(max - min, false);
	    d = SG.niceNum(range / (ntick - 1), true);
	    graphmin = Math.floor(min / d) * d;
	    graphmax = Math.ceil(max / d) * d;
	    nfrac = Math.max(-Math.floor(Math.log(d) / Math.LN10), 0);
	    for (x = graphmin; x <= graphmax + 0.5 * d; x += d) {
	      labelsAt.push(x);
	    }
	    return { tickValues: labelsAt, nfrac: nfrac };
	  };
	
	  SG.Metric = function (graph, key, opts) {
	    this._graph = graph;
	    this._key = key;
	    this._opts = opts || {};
	    // set up conversion and inverse conversion functions
	    if (key == 'time') {
	      // our "conversion" for time is just offsetting by first value
	      var firstTimeValue = this._graph.data()[0].time;
	      this.convert = function (x) {
	        return (x - firstTimeValue) / 60;
	      };
	      this.inverseConvert = function (x) {
	        return x * 60 + firstTimeValue;
	      };
	    } else {
	      this.convert = SG.defaultUnitConversions[key] || SG.identityFn;
	      this.inverseConvert = SG.defaultInverseUnitConversions[key] || SG.identityFn;
	    }
	    // initialize some private vars
	    this._computed = [];
	    this._axis = this._opts.axis || 'y';
	  };
	  SG.Metric.prototype = {
	    key: function key() {
	      return this._key;
	    },
	    computed: function computed() {
	      return this._computed;
	    },
	    addComputed: function addComputed(metric) {
	      this._computed.push(metric);
	    },
	    isComputed: function isComputed() {
	      return !!this._opts.type;
	    },
	    computedType: function computedType() {
	      return this._opts.type;
	    },
	    computedVariant: function computedVariant() {
	      return this._opts.variant;
	    },
	    description: function description() {
	      if (this.computedType() == 'ma') return this.computedVariant() + 's moving avg';else return 'UNSUPPORTED';
	    },
	    baseMetricKey: function baseMetricKey() {
	      return this.key().split('_')[0];
	    },
	    axis: function axis() {
	      return this._axis;
	    }
	  };
	
	  SG.defaultXAxisConfig = {
	    innerTicksLength: 4,
	    lineSideMargin: -1,
	    tickLabelMargin: 4,
	    tickLabelTextHeight: 10,
	    axisLabelMargin: 8,
	    axisLabelTextHeight: 10
	
	    /**
	     * Default options that a new graph is configured with.
	     * @class defaultOptions
	     */
	  };SG.defaultOptions = {
	    /**
	     * @property showXAxisLabel
	     * @default true
	     */
	    showXAxisLabel: true,
	    /**
	     * Display control bar
	     * @property displayControls
	     * @default true
	     */
	    displayControls: true,
	
	    /**
	      * Display light controls excluding
	      *
	      */
	    displayLightControls: false,
	    /**
	     * Enable reference-point and reference-selection support
	     */
	    referenceTools: false,
	    /**
	     * Enable the "edit" menu for a segment selection
	     */
	    editMenu: true,
	    /**
	     * Enable the "save as" menu for a segment selection
	     */
	    saveMenu: true,
	
	    enableUndoRedo: false,
	    /**
	     * Colors for each type of fill
	     */
	    fills: {
	      ele: '#cf635a',
	      paved: '#cf635a',
	      unknown: '#FAEFEE',
	      excluded: '#cccccc'
	    },
	    /**
	     * colors for each type of stroke
	     */
	    strokes: {
	      ele: '#ba676a',
	      excluded: '#cccccc',
	      hr: '#0048fb',
	      grade: '#666666',
	      cad: '#285c1d',
	      speed: '#000000',
	      watts: '#000000'
	    }
	
	    /**
	     * Global graph options that apply to all graphs instantiated.
	     * @class globalOptions
	     */
	  };SG.globalOptions = {
	    /**
	     * Delegate zooming to Data instance (which can be shared), allowing multiple graphs to zoom simultaneously.
	     * @property globalZoom
	     * @default true
	     */
	    globalZoom: true,
	    /**
	     * Listen for mousemove on any canvas
	     * @property globalHighlight
	     * @default true
	     */
	    globalHighlight: true
	  };
	
	  SG.defaultUnitConversions = {
	    distance: rwgps.Convert.mToLong,
	    ele: rwgps.Convert.mToShort,
	    temp: rwgps.Convert.cToDeg,
	    speed: rwgps.Convert.kmToLong
	  };
	  SG.defaultInverseUnitConversions = {
	    distance: rwgps.Convert.longToM,
	    ele: rwgps.Convert.shortToM,
	    temp: rwgps.Convert.degToC,
	    speed: rwgps.Convert.longToKm
	  };
	
	  SG.identityFn = function (x) {
	    return x;
	  };
	
	  // just return all the metrics we know about, in an order suitable for listing
	  SG.availableMetrics = function () {
	    return ['ele', 'grade', 'hr', 'cad', 'speed', 'watts'];
	  };
	
	  // TODO make this part of Metric
	  SG.unitsFor = function (metric) {
	    switch (metric) {
	      case 'hr':
	        return 'bpm';
	      case 'cad':
	        return 'rpm';
	      case 'watts':
	        return 'watts';
	      case 'grade':
	        return 'percent';
	      case 'ele':
	        return rwgps.LabelMaker.metric ? 'm' : 'ft';
	      case 'speed':
	        return rwgps.LabelMaker.metric ? 'kph' : 'mph';
	      case 'distance':
	        return rwgps.LabelMaker.metric ? 'km' : 'miles';
	      case 'temp':
	        return rwgps.LabelMaker.metric ? 'deg_c' : 'deg_f';
	    }
	  };
	
	  SG._registeredModules = {};
	
	  SG.registerModule = function (module) {
	    this._registeredModules[module] = true;
	  };
	
	  SG.isModuleLoaded = function (module) {
	    return !!this._registeredModules[module];
	  };
	
	  // export to global
	  module.exports = SG;
	})();

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	* Controls, render em and they do stuff
	*
	*/
	
	(function (SG, window, undefined) {
	  SG.registerModule('controls');
	  SG.bind('initialize:after', function (graph) {
	    graph.bindTo(graph, 'reflow', graph.repositionPlotToggles);
	    graph.bindTo(graph, 'data:change', graph.drawPlotToggles);
	    graph.bindTo(graph, 'partition:change', graph.drawPartitionControl);
	    graph.bindTo(graph, 'render:after', graph.drawPartitionControl);
	  });
	
	  var ControlsBar, SaveSelection, ChangeColor;
	
	  _.extend(SG.prototype, {
	    // draw the little checkboxes that you can click on to
	    // disable/enable metrics
	    drawPlotToggles: function drawPlotToggles() {
	      if (!this.controlsBar && this.get('displayControls')) {
	        this.controlsBar = new ControlsBar({ graph: this });
	      }
	      return;
	
	      // the below code supported metrics variants (moving averages for watts)
	      //
	      //if(this.$toggles) this.$toggles.remove();
	      //if(this.$variants) {
	      //  this.$variants.remove();
	      //  delete this.$variants;
	      //}
	      //// we'll need to figure out what metrics are actually available
	      //var metrics = this.metricsY(),
	      //  metricsEnabled = this.metricsEnabled(),
	      //  readOnly = false;
	      //
	      //this.$toggles = $('<div></div>')
	      //  .addClass(this.uniqueClass)
	      //  .addClass('sg-elem')
	      //  .addClass('sample-graph-toggles')
	      //  .css({zIndex: this.zIndex()});
	      //for(var i=0; i < metrics.length; i++) {
	      //  var metric = metrics[i];
	      //  var metricKey = metric.key();
	      //  $toggle = $('<label><input type="checkbox" value="'+metricKey+'">' + T.t('sample_graph.' + metricKey) + '</label>')
	      //    .addClass(metricKey);
	      //  return;
	      //  // check to see if there are computed versions of this metric
	      //  // to render
	      //  if(metric.computed().length > 0) {
	      //    var computed = metric.computed();
	      //    // only supporting one right now
	      //    this.$variants = $('<ul></ul>')
	      //      .addClass(this.uniqueClass)
	      //      .addClass('sg-elem')
	      //      .addClass('sg-variants')
	      //      .addClass('button2-vertical-group')
	      //      .data('metric', metricKey)
	      //      .css({zIndex: this.zIndex() + 1000}) // need it above labels!
	      //      .hide();
	      //    this.$variantsToggle = $('<a href="javascript:;">+ options</a>')
	      //      .addClass(this.uniqueClass)
	      //      .addClass('sg-elem')
	      //      .addClass('sg-variants-toggle')
	      //      .data('metric', metricKey)
	      //      .css({zIndex: this.zIndex()})
	      //      .hide();
	      //
	      //    // first add the original metric
	      //    var $variant = $('<li><a href="javascript:;">As recorded</a></li>')
	      //      .addClass('selected')
	      //      .data('metric', metric.key())
	      //      .appendTo(this.$variants);
	      //    for(var j=0; j < computed.length; j++) {
	      //      $variant = $('<li><a href="javascript:;">' + computed[j].description() + '</a></li>')
	      //        .data('metric', computed[j].key())
	      //        .appendTo(this.$variants);
	      //    }
	      //    $variant.addClass('last');
	      //    var self = this;
	      //    // handle click to swap in a metric variant
	      //    this.$variants.delegate('a', 'click', function() {
	      //      var metricKey = $(this).closest('li').data('metric'),
	      //        baseMetricKey = $(this).closest('ul').data('metric');
	      //      self.$toggles.find('.' + baseMetricKey + ' input').val(metricKey);
	      //      // update the ui for selected
	      //      $(this).closest('ul').find('.selected').removeClass('selected');
	      //      $(this).closest('li').addClass('selected');
	      //      self.refreshMetricsEnabled();
	      //    });
	      //    this.$variantsToggle.click(function() {
	      //      self.$variants.toggle();
	      //      self.repositionPlotToggles();
	      //    });
	      //  }
	
	      //  if(_.include(metricsEnabled, metricKey)) {
	      //    $toggle.find('input').attr('checked', 'checked');
	      //    if(metricsEnabled.length == 1)
	      //      $toggle.find('input').attr('disabled', true);
	      //  }
	
	      //  $toggle.appendTo(this.$toggles);
	      //}
	      //if(this.$variants) {
	      //  this.$variants.prependTo('body');
	      //  this.$variantsToggle.prependTo('body');
	      //}
	      //this.$toggles.prependTo('body');
	      //this.repositionPlotToggles();
	      //var self = this;
	      //this.$toggles.delegate('input', 'change', function() {
	      //  // sorry this is hardcoded for now, still not sure how i want
	      //  // this interface to look / work anyway
	      //  if($(this).closest('label').hasClass('watts') && self.$variants) {
	      //    if($(this).is(':checked'))
	      //      self.$variantsToggle.show();
	      //    else {
	      //      self.$variantsToggle.hide();
	      //      self.$variants.hide();
	      //    }
	      //  }
	      //  self.refreshMetricsEnabled();
	      //});
	      //if(self.$variants && metrics.length == 1)
	      //  self.$variantsToggle.show();
	    },
	
	    drawPartitionControl: function drawPartitionControl(partition) {
	      if (!partition) partition = this.partition();
	      if (this._partitionSeparators) {
	        _.each(this._partitionSeparators, function (el) {
	          el.remove();
	        });
	      }
	      if (!partition) {
	        delete this._partitionSeparators;
	        return;
	      }
	
	      var slices = partition.slices(),
	          offset = this.$canvas.offset(),
	          plotMargin = this.plotMargin(),
	          xAxisType = this.xAxisType();
	
	      var separators = this._partitionSeparators = [];
	
	      for (var i = 0; i < slices.length - 1; i++) {
	        var slice = slices[i],
	            left = this.plotToPixel(slice.lastPoint()[xAxisType]) + offset.left - 5,
	            top = offset.top + plotMargin.top,
	            $separator = $('<div><div class="middle"></div></div>').addClass(this.uniqueClass).addClass('sg-elem').addClass('sg-partition-separator').css({ zIndex: this.zIndex(), position: 'absolute' }).offset({ top: top, left: left }).height(this.plotHeight).find('.middle').height(this.plotHeight).end().prependTo(this.$body);
	        separators.push($separator);
	      }
	    },
	
	    standardBoundsTestFn: function standardBoundsTestFn($el, buffer) {
	      return function (x, y) {
	        var offset = $el.offset(),
	            width = $el.width(),
	            height = $el.height();
	        if (buffer) {
	          offset.left -= buffer;
	          width += buffer * 2;
	        }
	        return x > offset.left && x < offset.left + width && y > offset.top && y < offset.top + height;
	      };
	    },
	
	    inBoundsOfControl: function inBoundsOfControl(x, y) {
	      if (!this.activeControlsBoundsTests) return false;
	      var node = this.activeControlsBoundsTests,
	          tail = node.tail;
	      while ((node = node.next) !== tail) {
	        if (node.fn.call(this, x, y)) return true;
	      }
	      return false;
	    },
	
	    addControlBoundsTest: function addControlBoundsTest(fn) {
	      var list = this.activeControlsBoundsTests || (this.activeControlsBoundsTests = {}),
	          tail = list.tail || (list.tail = list.next = {});
	      tail.fn = fn;
	      list.tail = tail.next = {};
	    },
	
	    removeControlBoundsTest: function removeControlBoundsTest(fn) {
	      var node, prev;
	      if (node = prev = this.activeControlsBoundsTests) {
	        // eslint-disable-line no-cond-assign
	        while ((node = node.next) && node.next) {
	          if (node.fn === fn) {
	            prev.next = node.next;
	            break;
	          }
	          prev = node;
	        }
	      }
	    },
	
	    repositionPlotToggles: function repositionPlotToggles() {
	      if (this.controlsBar) this.controlsBar.reposition();
	    }
	  });
	
	  ControlsBar = Backbone.View.extend({
	    className: 'sg-bar',
	    tmplId: 'sg-tmpl-control-bar',
	    metricsTmplId: 'sg-tmpl-control-bar-metrics',
	    initialize: function initialize() {
	      _.bindAll(this, 'onSegmentSelect', 'onSegmentDeselect', 'renderMetricsToggles', 'updateDisplayOfIncludeInMetrics', 'referencePoint');
	
	      this.graph = this.options.graph;
	      this.render();
	      this.$el.addClass(this.graph.uniqueClass);
	      this.$el.prependTo(this.graph.$canvas.parent());
	
	      // add boudns test for the dropdowns (only applies when they are open)
	      _.each(this.$('.dropdown-menu,.menu-container'), function (el) {
	        this.graph.addControlBoundsTest(this.graph.standardBoundsTestFn($(el)));
	      }, this);
	
	      this.graph.bindTo(this.graph, 'segmentselector:load', this.onSegmentSelect);
	      this.graph.bindTo(this.graph, 'segmentselector:unload', this.onSegmentDeselect);
	      this.graph.bindTo(this.graph, 'data:change', this.renderMetricsToggles);
	      this.graph.bindTo(this.graph, 'dataslice:select', this.updateDisplayOfIncludeInMetrics);
	    },
	    updateDisplayOfIncludeInMetrics: function updateDisplayOfIncludeInMetrics(dataSlice) {
	      this.$el.find('.sg-controls-unexclude-from-metrics')[dataSlice.points().find(function (pt) {
	        return pt.excludeFromMetrics;
	      }) ? 'show' : 'hide']();
	    },
	    render: function render() {
	      this.$el.html(SG.template(this.tmplId, {
	        graph: this.graph
	      }));
	      this.renderMetricsToggles();
	      return this;
	    },
	    renderMetricsToggles: function renderMetricsToggles() {
	      var metrics = _.map(this.graph.metricsY(), function (metric) {
	        return metric.key();
	      });
	      if (metrics.length === 0) {
	        // this can still happen if we 1) import a route w/o st and then 2) clear map
	        if (Routes.activeMap.activeRoute.showSurface) {
	          metrics = ['ele', 'surfaces', 'grade'];
	        } else {
	          metrics = ['ele', 'grade'];
	        }
	      } else if (metrics.indexOf('surfaces') > 0 && !Routes.activeMap.activeRoute.showSurface) {
	        metrics.remove(metrics.indexOf('surfaces'), 0);
	      } else if (_.isEqual(metrics, ['surfaces'])) {
	        // we hit this on first load
	        metrics.unshift('ele');
	      }
	      this.$('.sg-controls-metrics').html(SG.template(this.metricsTmplId, {
	        metrics: metrics
	      }));
	      var metricsEnabled = this.graph.metricsEnabled();
	      if (metricsEnabled.length === 0) {
	        if (Routes.activeMap.activeRoute.showSurface) {
	          metricsEnabled = ['ele', 'surfaces'];
	        } else {
	          metricsEnabled = ['ele'];
	        }
	      }
	
	      _.each(metricsEnabled, function (metricKey) {
	        this.$('.sg-controls-metrics a[data-metric="' + metricKey + '"]').closest('li').addClass('active');
	      }, this);
	    },
	    events: {
	      // available when zoomed in
	      'click .sg-controls-re-center': 'reCenter',
	      'click .sg-controls-deselect': 'unload',
	
	      // available always
	      'click .sg-controls-zoom-out': 'zoomOut',
	      'click .sg-controls-metrics a': 'toggleMetric',
	      'click .sg-controls-minimize': 'minimize',
	      'click .sg-controls-restore': 'restore',
	      'click .sg-controls-expand-graphs': 'expandGraphs',
	
	      // edit dropdown
	      'click .edit_menu a': 'onModified',
	      'click .sg-controls-trim-ends': 'crop',
	      'click .sg-controls-delete-selection': 'removePoints',
	      'click .sg-controls-flatten-elevation': 'flattenElevation',
	      'click .sg-controls-exclude-from-metrics': 'excludeFromMetrics',
	      'click .sg-controls-unexclude-from-metrics': 'unexcludeFromMetrics',
	      'click .sg-controls-change-color': 'openChangeColor',
	      'click .sg-controls-remove-control-points': 'removeControlPoints',
	      'click .sg-controls-remove-metric': 'onRemoveMetricClick',
	
	      // save as dropdown
	      'click .sg-controls-save-route': 'saveRoute',
	      'click .sg-controls-save-trip': 'saveTrip',
	      'click .sg-controls-save-segment': 'saveSegment',
	      'click .sg-controls-save-annotation': 'saveAnnotation',
	
	      // persist ops
	      'click .sg-persist-ops .save': 'save',
	      'click .sg-persist-ops .revert': 'revert',
	
	      // reference tools
	      'click .sg-controls-reference-point': 'toggleReferencePoint',
	      'click .sg-controls-reference-segment': 'referenceSegment',
	
	      // planner mode
	      'click .sg-controls-undo': 'undo',
	      'click .sg-controls-redo': 'redo'
	    },
	    undo: function undo() {
	      Routes.activeMap.undo();
	    },
	    redo: function redo() {
	      Routes.activeMap.redo();
	    },
	    minimize: function minimize() {
	      Routes.activeMap.hideElevation();
	      this.$el.addClass('collapsed');
	    },
	    restore: function restore() {
	      Routes.activeMap.showElevation();
	      this.$el.removeClass('collapsed');
	    },
	    expandGraphs: function expandGraphs() {
	      this.graph.trigger('expand_graphs');
	    },
	    onSegmentSelect: function onSegmentSelect() {
	      this.$('.sg-selection-tools').show();
	      this.reposition();
	      this.graph.resize();
	    },
	    toggleMetric: function toggleMetric(e) {
	      var $li = $(e.target).closest('li');
	      if ($li.hasClass('disabled')) return;
	
	      var $checkedBefore = $li.closest('ul').find('.active a');
	      if ($li.hasClass('active')) {
	        if ($checkedBefore.length === 1) {
	          // don't let them de-select the last one!
	          return;
	        } else if (e.target.dataset.metric === 'ele' && JSON.stringify($checkedBefore.toArray().map(function (e) {
	          return e.dataset.metric;
	        })) === JSON.stringify(['ele', 'surfaces'])) {
	          // deselecting ele counts as deselecting the last one if the only other selected metric is surfaces
	          return;
	        }
	
	        $li.removeClass('active');
	        if (e.target.dataset.metric === 'ele') {
	          // if we're deselecting ele, also deselect (and disable) surfaces
	          var stLi = $checkedBefore.addBack().find('[data-metric="surfaces"]').closest('li');
	          if (stLi.length > 0) {
	            this.graph.showSurface(false);
	            stLi.removeClass('active');
	            stLi.addClass('disabled');
	          }
	        }
	      } else {
	        $li.addClass('active');
	        if (e.target.dataset.metric === 'ele') {
	          // if we're selecting ele, also re enable surfaces
	          var _stLi = $checkedBefore.addBack().find('[data-metric="surfaces"]').closest('li');
	          if (_stLi.length > 0) {
	            _stLi.removeClass('disabled');
	          }
	        }
	      }
	
	      var $checkedAfter = $li.closest('ul').find('.active a');
	      var metrics = $checkedAfter.map(function () {
	        return $(this).data('metric');
	      });
	      this.graph.metricsEnabled(metrics);
	      if (e.target.dataset.metric === 'surfaces') {
	        this.graph.toggleShowSurface();
	      }
	      this.graph.render();
	    },
	    zoomOut: function zoomOut() {
	      if (this.graph.zoomedIn()) this.graph.zoomOutOnClick(null, false);else this.graph.recenterMap();
	    },
	    reCenter: function reCenter() {
	      this.graph.segmentSelector.reCenter();
	    },
	    unload: function unload() {
	      this.graph.segmentSelector.unload();
	      this.graph.resize();
	    },
	    onSegmentDeselect: function onSegmentDeselect() {
	      this.$('.sg-selection-tools').hide();
	      if (this.saveSelection) this.closeSaveForm();
	      if (this.changeColor) this.closeColorChange();
	    },
	    reposition: function reposition() {
	      this.$el.width(this.graph.width());
	      if (this.saveSelection) {
	        this.saveSelection.reposition();
	      }
	    },
	
	    onModified: function onModified() {
	      if (this.graph.options.segmentSelectorMode != 'planner') {
	        this.$('.sg-persist-ops').show();
	        this.reposition();
	      }
	    },
	    saveSegment: function saveSegment() {
	      if (this.saveSelection) this.closeSaveForm();
	      this.saveSelection = new SaveSelection({ graph: this.graph });
	      this.saveSelection.showSaveSegmentForm();
	    },
	    saveAnnotation: function saveAnnotation() {
	      if (this.saveSelection) this.closeSaveForm();
	      this.saveSelection = new SaveSelection({ graph: this.graph });
	      this.saveSelection.showSaveAnnotationForm();
	    },
	    saveTrip: function saveTrip() {
	      if (this.saveSelection) this.closeSaveForm();
	      this.saveSelection = new SaveSelection({ graph: this.graph });
	      this.saveSelection.showSaveTripForm();
	    },
	    saveRoute: function saveRoute() {
	      if (this.saveSelection) this.closeSaveForm();
	      this.saveSelection = new SaveSelection({ graph: this.graph });
	      this.saveSelection.showSaveRouteForm();
	    },
	    save: function save() {
	      var route = Routes.activeMap.activeRoute.toSaveObj(),
	          params = rwgps.csrfParams(),
	          view = this,
	          $saveButton = this.$('.sg-persist-ops .save');
	      params._method = 'put';
	      params[rwgps.config.assetType == "route" ? "route" : "trip"] = {
	        track_points: JSON.stringify(route.track_points)
	      };
	      $.post(rwgps.config.assetPath, params, function () {
	        $saveButton.html("Save");
	        $saveButton.removeClass('disabled');
	        view.$('.sg-persist-ops').hide();
	        view.reposition();
	        $.jGrowl("Successfully updated " + rwgps.config.assetType + "!");
	      });
	      $saveButton.addClass('disabled');
	      $saveButton.html("<i class='icon-spinner icon-spin'></i> Saving...");
	    },
	    revert: function revert() {
	      window.location.reload();
	    },
	    toggleReferencePoint: function toggleReferencePoint() {
	      if (this._referencePointEnabled) {
	        this.disableReferencePoint();
	      } else {
	        this.enableReferencePoint();
	      }
	    },
	    enableReferencePoint: function enableReferencePoint() {
	      if (this.graph.segmentSelector) {
	        var slice = this.graph.zoomedSlice();
	        this.graph.segmentSelector.unload();
	        this.enableReferencePoint();
	        this.graph.zoomToDataSlice(slice);
	        return;
	      }
	      this.$('.sg-controls-reference-point').closest('li').addClass('active');
	      this.graph.bindTo(this.graph, 'pointselected', this.referencePoint);
	
	      // standard zoom-on-drag allows zooming in to select point
	      this._revertDragBehaviorToSelectSegment = this.graph.segmentselectedBehavior == 'select_segment';
	      this.graph.setDragBehaviorToZoomIn();
	
	      this._referencePointEnabled = true;
	      this.graph.trigger('reference:point:mode_enabled');
	    },
	    disableReferencePoint: function disableReferencePoint() {
	      this.$('.sg-controls-reference-point').closest('li').removeClass('active');
	      this.graph.unbindFrom(this.graph, 'pointselected', this.referencePoint);
	      if (this.graph.zoomedIn()) this.graph.zoomOut();
	      if (this._revertDragBehaviorToSelectSegment) {
	        delete this._revertDragBehaviorToSelectSegment;
	        this.graph.setDragBehaviorToSelectSegment();
	      }
	      this._referencePointEnabled = false;
	      this.graph.trigger('reference:point:mode_disabled');
	    },
	    referencePointEnabled: function referencePointEnabled() {
	      return this._referencePointEnabled;
	    },
	    referencePoint: function referencePoint(i) {
	      this.disableReferencePoint();
	      this.graph.trigger('reference:point', i);
	    },
	    referenceSegment: function referenceSegment() {
	      this.graph.trigger('reference:segment', this.dataSlice());
	    },
	    dataSlice: function dataSlice() {
	      return this.graph.segmentSelector.dataSlice;
	    },
	    removePoints: function removePoints() {
	      if (this.graph.options.segmentSelectorMode === 'planner') {
	        // in the route planner, we've got multi-route editing, so cutting out the selected slice
	        // and ending up with two routes is OK
	        this.removeSlice();
	        return;
	      }
	
	      var dataSlice = this.dataSlice();
	      this.graph.segmentSelector.unload();
	      var pt = dataSlice.firstPoint();
	      var route = (pt.segment || pt.nextSegment).route;
	      var map = route.map;
	      var newRoute = route.removeSlice(dataSlice);
	      var connectingSeg = route.lastSegment;
	      if (newRoute) {
	        map.removeRoute(newRoute);
	        var offsetDist = connectingSeg.nextControlPoint.distance + connectingSeg.nextControlPoint.distanceFromPoint(newRoute.firstSegment.prevControlPoint) - newRoute.firstSegment.prevControlPoint.distance;
	        _.each(newRoute.trackPoints(), function (pt) {
	          pt.distance += offsetDist;
	        });
	        connectingSeg.nextControlPoint.setNextSegment(newRoute.firstSegment);
	        connectingSeg.slurpNext();
	      }
	      route.rebuildBounds();
	      route.redraw();
	      route.calculateMetrics();
	    },
	    crop: function crop() {
	      var dataSlice = this.dataSlice();
	      this.unloadWithoutRecenter();
	      var pt = dataSlice.firstPoint();
	      (pt.segment || pt.nextSegment).route.cropTo(dataSlice);
	      Routes.activeMap.activeRoute.redraw();
	    },
	    unloadWithoutRecenter: function unloadWithoutRecenter() {
	      var segmentSelector = this.graph.segmentSelector;
	      Routes.activeMap.withRecenterDisabled(function () {
	        segmentSelector.unload();
	      });
	    },
	    flattenElevation: function flattenElevation() {
	      var slice = this.dataSlice(),
	          firstPt = slice.firstPoint(),
	          lastPt = slice.lastPoint(),
	          domain = this.graph.metricsCalculatorForDataToRender().hasDistance() ? "distance" : "time",
	          domainOffset = firstPt[domain],
	          mult = (lastPt.ele - firstPt.ele) / (lastPt[domain] - firstPt[domain]);
	      _.each(this.dataSlice().points(), function (pt) {
	        pt.ele = (pt[domain] - domainOffset) * mult + firstPt.ele;
	      });
	      this.graph.render();
	      this.unloadWithoutRecenter();
	    },
	    changeSurfaceTo: function changeSurfaceTo(surface) {
	      var dataSlice = this.dataSlice();
	      dataSlice.points().forEach(function (tp) {
	        tp.surface = surface;
	        tp.ghSurface = surface; // need to overwrite this so this modification isn't reverted on snapshot/reload
	        tp.modified = true;
	      });
	      var route = Routes.activeMap.activeRoute;
	      route.recalculatePolylines();
	      Routes.activeMap.drawRouteDistanceMarkers();
	      Routes.activeMap.drawCoursePointIcons(route.coursePoints());
	      Routes.activeMap.snapshot();
	      rwgps.Events.trigger('surfacesChanged');
	      this.graph.render();
	      this.unloadWithoutRecenter();
	    },
	    removeControlPoints: function removeControlPoints() {
	      var slice = this.dataSlice(),
	          firstPt = slice.firstPoint(),
	          lastPt = slice.lastPoint(),
	          firstSeg = firstPt.segment || firstPt.nextSegment || firstPt.prevSegment,
	          lastSeg = lastPt.segment || lastPt.prevSegment || lastPt.nextSegment;
	
	      // check to see if there's a cp in the slice, bail if there isn't
	      if (firstSeg._segId === lastSeg._segId) {
	        return;
	      }
	
	      // walk segments, slurping next until we catch up to lastSeg or we reach the end
	      while (firstSeg && lastSeg && firstSeg._segId !== lastSeg._segId && !!firstSeg.nextSegment) {
	        firstSeg.slurpNext();
	        firstSeg = firstPt.segment || firstPt.nextSegment || firstPt.prevSegment;
	        lastSeg = lastPt.segment || lastPt.prevSegment || lastPt.nextSegment;
	      }
	
	      // add new controlpoints on either end of initial slice
	      if (lastPt.segment) {
	        var lastSegmentI = _.indexOf(lastSeg.trackPoints, lastPt);
	        lastSeg.splitAfter(lastSegmentI - 1);
	      }
	
	      if (firstPt.segment) {
	        var firstSegmentI = _.indexOf(firstSeg.trackPoints, firstPt);
	        firstSeg.splitAfter(firstSegmentI - 1);
	      }
	      this.unloadWithoutRecenter();
	    },
	    excludeFromMetrics: function excludeFromMetrics(reverseOperation) {
	      var dataSlice = this.dataSlice();
	      this.graph.segmentSelector.unload();
	      var firstPoint = dataSlice.firstPoint();
	      var lastPoint = dataSlice.lastPoint();[dataSlice.firstPoint(), dataSlice.lastPoint()].forEach(function (endPoint) {
	        if (endPoint.segment) {
	          endPoint.segment.splitAfter(endPoint.segment.trackPoints.indexOf(endPoint) - 1);
	        }
	      });
	      var lastSegment = lastPoint.segment || lastPoint.prevSegment;
	      var route = lastSegment.route;
	      // if we split the segment, we need to advance before excluding.
	      // if we did not split (the selection was on a control point), then exclude the firstSegment
	      var segment = firstPoint.nextSegment;
	      do {
	        segment.setExcludeFromMetrics(!(reverseOperation === true), true);
	      } while ((segment = segment.nextSegment) !== lastSegment.nextSegment && segment);
	      route.redraw();
	      route.calculateMetrics();
	      Routes.activeMap.drawRouteDistanceMarkers();
	      Routes.activeMap.snapshot();
	    },
	    unexcludeFromMetrics: function unexcludeFromMetrics() {
	      this.excludeFromMetrics(true);
	    },
	    openChangeColor: function openChangeColor() {
	      this.changeColor = new ChangeColor({ graph: this.graph });
	      this.changeColor.showChangeColor();
	    },
	    changeColorTo: function changeColorTo(color) {
	      var dataSlice = this.dataSlice();
	      this.graph.segmentSelector.unload();
	      var firstPoint = dataSlice.firstPoint();
	      var lastPoint = dataSlice.lastPoint();[dataSlice.firstPoint(), dataSlice.lastPoint()].forEach(function (endPoint) {
	        if (endPoint.segment) {
	          endPoint.segment.splitAfter(endPoint.segment.trackPoints.indexOf(endPoint) - 1);
	        }
	      });
	      var lastSegment = lastPoint.segment || lastPoint.prevSegment;
	      var route = lastSegment.route;
	      var segment = firstPoint.nextSegment;
	      do {
	        segment.color = color;
	      } while ((segment = segment.nextSegment) !== lastSegment.nextSegment && segment);
	      route.redraw();
	      Routes.activeMap.drawRouteDistanceMarkers();
	      Routes.activeMap.drawCoursePointIcons(route.coursePoints());
	      Routes.activeMap.snapshot();
	    },
	    onRemoveMetricClick: function onRemoveMetricClick(e) {
	      this.removeMetric($(e.currentTarget).data('metric'));
	    },
	    removeMetric: function removeMetric(metric) {
	      _.each(this.dataSlice().points(), function (pt) {
	        pt[metric] = undefined;
	      });
	      this.graph.render();
	    },
	    closeSaveForm: function closeSaveForm() {
	      this.saveSelection.$el.remove();
	      delete this.saveSelection;
	    },
	    closeColorChange: function closeColorChange() {
	      this.changeColor.$el.remove();
	      delete this.changeColor;
	    },
	    removeSlice: function removeSlice() {
	      var dataSlice = this.dataSlice();
	      this.unloadWithoutRecenter();
	      var pt = dataSlice.firstPoint();
	      (pt.segment || pt.nextSegment).route.removeSlice(dataSlice);
	    }
	  });
	
	  SaveSelection = Backbone.View.extend({
	    className: 'sg-segment-selector-save-form',
	    tmplId: 'sg-tmpl-save-segment',
	    initialize: function initialize() {
	      this.graph = this.options.graph;
	      this.render();
	      this.$el.prependTo('body');
	    },
	    events: {
	      // initially visible actions
	      'click .sg-cancel': 'close',
	
	      // save segment
	      'change .sg-save-segment select.matching_scope': 'onMatchingScopeChange',
	      'keypress .sg-save-segment input.title': 'onEnterSaveSegment',
	      'click .sg-save-segment .sg-save': 'saveSegment',
	
	      // save annotation
	      'keypress .sg-save-annotation input.comment': 'onEnterAnnotate',
	      'click .sg-save-annotation .sg-annotate': 'annotate',
	
	      // save trip
	      'keypress .sg-save-trip input.name': 'onEnterSaveTrip',
	      'click .sg-save-trip .sg-save': 'saveTrip',
	
	      // save route
	      'keypress .sg-save-route input.name': 'onEnterSaveRoute',
	      'click .sg-save-route .sg-save': 'saveRoute'
	    },
	    onMatchingScopeChange: function onMatchingScopeChange() {
	      var matchingScope = this.$('.matching_scope').val();
	      this.$('.matching_scope_dep').hide(); // hide group/event options if visible
	      if (rwgps.config.currentUser.account_level < 2 && (matchingScope == 'user' || matchingScope == 'group' || matchingScope == 'event')) {
	        // restricted to premium only!
	        this.$('.matching_scope_restricted').show();
	        setTimeout(function () {
	          this.$('.matching_scope').val('public');
	        }, 500);
	      } else if (matchingScope == 'group') {
	        this.$('.matching_scope_group').show();
	      } else if (matchingScope == 'event') {
	        this.$('.matching_scope_event').show();
	      }
	    },
	    reposition: function reposition() {
	      var offset = this.graph.controlsBar.$('.sg-selection-tools a:first').offset(),
	          left;
	
	      left = offset.left - this.$el.width() / 2;
	      this.$el.offset({ left: left, top: offset.top - this.$el.height() - 20 });
	    },
	    render: function render() {
	      this.$el.html(SG.template(this.tmplId, {
	        user: rwgps.config.currentUser,
	        groups: rwgps.activeNs.adminGroups,
	        events: rwgps.activeNs.adminEvents
	      })).css({ zIndex: this.graph.zIndex(), position: 'absolute' });
	      return this;
	    },
	    showSaveSegmentForm: function showSaveSegmentForm() {
	      this.$('.sg-save-segment').show();
	      this.$('.title').focus();
	      this.reposition();
	    },
	    showSaveAnnotationForm: function showSaveAnnotationForm() {
	      this.$('.sg-save-annotation').show();
	      this.$('.comment').focus();
	      this.reposition();
	    },
	    showSaveRouteForm: function showSaveRouteForm() {
	      this.$('.sg-save-route').show();
	      this.$('.name').focus();
	      this.reposition();
	    },
	    showSaveTripForm: function showSaveTripForm() {
	      this.$('.sg-save-trip').show();
	      this.$('.name').focus();
	      this.reposition();
	    },
	    onEnterAnnotate: function onEnterAnnotate(e) {
	      if (e.keyCode == 13) this.annotate();
	    },
	    onEnterSaveSegment: function onEnterSaveSegment(e) {
	      if (e.keyCode == 13) this.saveSegment();
	    },
	    onEnterSaveTrip: function onEnterSaveTrip(e) {
	      if (e.keyCode == 13) this.saveTrip();
	    },
	    onEnterSaveRoute: function onEnterSaveRoute(e) {
	      if (e.keyCode == 13) this.saveRoute();
	    },
	    close: function close() {
	      this.graph.controlsBar.closeSaveForm();
	    },
	    saveTrip: function saveTrip() {
	      var graph = this.graph,
	          dataSlice = graph.controlsBar.dataSlice(),
	          params = rwgps.csrfParams();
	      params.i = dataSlice.i;
	      params.count = dataSlice.count;
	      params.name = this.$('.sg-save-trip .name').val();
	      var privacyCode = new URLSearchParams(window.location.search).get('privacy_code');
	      if (privacyCode) params.privacy_code = privacyCode;
	      $.post('/trips/' + rwgps.config.assetId + '/new_from_slice.json', params, function (data) {
	        $.jGrowl("New ride saved: <a href='/trips/" + data.id + "'>View ride</a>");
	        graph.segmentSelector.unload();
	      });
	    },
	    saveRoute: function saveRoute() {
	      var graph = this.graph,
	          dataSlice = graph.controlsBar.dataSlice(),
	          params = rwgps.csrfParams();
	      params.i = dataSlice.i;
	      params.count = dataSlice.count;
	      params.assetType = rwgps.config.assetType;
	      params.assetId = rwgps.config.assetId;
	      params.name = this.$('.sg-save-route .name').val();
	      var privacyCode = new URLSearchParams(window.location.search).get('privacy_code');
	      if (privacyCode) params.privacy_code = privacyCode;
	      $.post('/routes/new_from_slice.json', params, function (data) {
	        $.jGrowl("New route created: <a href='/routes/" + data.id + "'>View route</a>");
	        graph.segmentSelector.unload();
	      });
	    },
	    saveSegment: function saveSegment() {
	      var graph = this.graph,
	          dataSlice = graph.controlsBar.dataSlice(),
	          title = this.$('input.title').val(),
	          matchingScope = this.$('select.matching_scope').val();
	      if (title.replace(/ /g, '') == '') {
	        customAlert('Please enter a name for the segment before saving.');
	        return;
	      }
	
	      var points = JSON.stringify(_.map(_.filter(dataSlice.data(), function (pt) {
	        return pt.point;
	      }), function (pt) {
	        return pt.toMiniObj();
	      }));
	      var segmentAttrs = {
	        title: title,
	        matching_scope: matchingScope,
	        points: points,
	        created_from_type: this.graph.options.segmentCreatedFromType,
	        created_from_id: this.graph.options.segmentCreatedFromId
	      };
	      if (matchingScope == 'group') {
	        segmentAttrs.group_id = this.$('.matching_scope_group select').val();
	      } else if (matchingScope == 'event') {
	        segmentAttrs.event_id = this.$('.matching_scope_event select').val();
	      }
	      $.post('/segments', {
	        segment: segmentAttrs
	      }, function (data) {
	        graph.trigger('segmentselector:create', data.segment);
	        graph.segmentSelector.unload();
	      });
	    },
	    annotate: function annotate() {
	      var graph = this.graph,
	          dataSlice = graph.controlsBar.dataSlice(),
	          comment = this.$('input.comment').val();
	      if (comment.replace(/ /g, '') == '') {
	        customAlert('Please enter an annotation, which is just a comment on the selected segment.');
	        return;
	      }
	      var annotation = {
	        first_i: dataSlice.i,
	        count: dataSlice.count,
	        comment: comment
	      };
	      $.post('/' + this.graph.options.segmentCreatedFromType + 's/' + this.graph.options.segmentCreatedFromId + '/annotate_segment.json', {
	        segment: annotation
	      }, function () {
	        graph.segmentSelector.unload();
	      });
	      this.graph.trigger('annotation:added', annotation);
	    }
	  });
	
	  ChangeColor = Backbone.View.extend({
	    className: 'sg-segment-selector-change-color',
	    tmplId: 'sg-tmpl-change-color',
	    initialize: function initialize() {
	      this.graph = this.options.graph;
	      this.render();
	      this.$el.prependTo('body');
	    },
	    events: {
	      'click .sg-cancel': 'close'
	    },
	    render: function render() {
	      this.$el.html(SG.template(this.tmplId, {})).css({ zIndex: this.graph.zIndex(), position: 'absolute' });
	      return this;
	    },
	    changeColorTo: function changeColorTo(color) {
	      this.graph.controlsBar.changeColorTo(color);
	    },
	    showChangeColor: function showChangeColor() {
	      this.$('.color_picker').colorPicker({
	        click: _.bind(function (color) {
	          this.changeColorTo(parseInt('0x' + color.split("#")[1]));
	        }, this),
	        defaultColor: 999, // hack to force no default
	        color: Routes.colors,
	        columns: 7
	      });
	      this.reposition();
	    },
	    reposition: SaveSelection.prototype.reposition,
	    close: function close() {
	      this.graph.controlsBar.closeColorChange();
	    }
	  });
	})(SampleGraph, window);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*
	* Drawing functions for Sample Graph, all in one convenient location.
	*
	*/
	
	(function (SG, window, undefined) {
	  _.extend(SG.prototype, {
	    // given a canvas y coord, draw a dashed horizontal line
	    // nice to draw at 0 for grade, or a goal speed, etc
	    drawHorizontalLine: function drawHorizontalLine(y, strokeStyle) {
	      var ctx = this.ctx,
	          pmd = this.plotMetaData[this.xAxisType()],
	          left = this.plotToPixel(pmd.min),
	          right = this.plotToPixel(pmd.max);
	      ctx.beginPath();
	      // lets draw a dashed line
	      var dashLen = 6,
	          spacing = 6;
	      while (left + dashLen <= right) {
	        ctx.moveTo(left, y);
	        left += dashLen;
	        ctx.lineTo(left, y);
	        left += spacing;
	      }
	      if (strokeStyle) {
	        ctx.strokeStyle = strokeStyle;
	        ctx.stroke();
	        ctx.restore();ctx.save();
	      } else {
	        ctx.stroke();
	      }
	    },
	
	    drawXAxis: function drawXAxis() {
	      var conf = this.xAxisConfig();
	      var top = this.height() - this.plotMargin().bottom;
	      var xAxisType = this.xAxisType();
	      var metric = this.metrics(xAxisType);
	      var inverseConversionFn = metric.inverseConvert;
	      var pmd = this.plotMetaData[xAxisType];
	      var min = pmd.min;
	      var max = pmd.max;
	      var tickValues = pmd.tickValues;
	      var numTicks = tickValues.length;
	      var ctx = this.ctx;
	      var right = this.plotToPixel(max);
	      var left = this.plotToPixel(min);
	      var baselineYOffset = top + conf.lineSideMargin;
	      var label;
	
	      ctx.beginPath();
	      // axis line
	      ctx.moveTo(left, baselineYOffset);
	      ctx.lineTo(right, baselineYOffset);
	      // tick marks with labels
	      for (var i = 0; i < numTicks; i++) {
	        var x;
	        var convertedPlotVal = tickValues[i];
	        var plotVal = inverseConversionFn(tickValues[i]);
	        x = this.plotToPixel(plotVal);
	        var height = conf.innerTicksLength;
	        var tickEndY = baselineYOffset + height;
	        ctx.moveTo(x, baselineYOffset);
	        ctx.lineTo(x, tickEndY);
	        // label
	        label = this.formatNumber(convertedPlotVal, xAxisType);
	        this.placeText(label, x, Math.round(baselineYOffset + conf.tickLabelMargin), { align: 'center' });
	      }
	      // center the label
	      label = this.xAxisLabel();
	
	      if (this.get('showXAxisLabel')) {
	        this.placeText(label, this.plotWidth / 2 + this.plotMargin().left, baselineYOffset + conf.innerTicksLength + conf.tickLabelMargin + conf.tickLabelTextHeight, { align: 'center' });
	      }
	      ctx.stroke();
	    },
	
	    xAxisLabel: function xAxisLabel() {
	      var label,
	          xAxisType = this.xAxisType();
	      var otherxaxis = xAxisType == 'distance' ? 'time' : 'distance';
	      if (xAxisType == 'distance') label = T.t('sample_graph.distance_in') + ' ' + T.t('sample_graph.' + SG.unitsFor(xAxisType));else label = T.t('sample_graph.time_from_start');
	      if (this.metricsX().length == 2) {
	        label += " (<a href='javascript:;' class='sample-graph-x-axis-use-" + otherxaxis + "'>" + T.t('sample_graph.switch_to') + ' ' + T.t('sample_graph.' + otherxaxis) + "</a>)";
	      }
	      return label;
	    },
	
	    placeText: function placeText(html, canvasX, canvasY, opts) {
	      if (!opts) opts = {};
	      var pageCoords = this.canvasToPageCoords(canvasX, canvasY);
	      var $text = $('<span>' + html + '</span>').addClass(this.uniqueClass).addClass('sg-elem').addClass('sample-graph-render-text').css({ zIndex: this.zIndex() }).prependTo(this.$canvas.parent());
	      switch (opts.align) {
	        case 'center':
	          pageCoords.x -= $text.width() / 2;
	          break;
	        case 'right':
	          pageCoords.x -= $text.width();
	          break;
	      }
	      switch (opts.vAlign) {
	        case 'middle':
	          pageCoords.y -= $text.height() / 2 - 1;
	      }
	      $text.offset({ top: pageCoords.y, left: pageCoords.x });
	      return $text;
	    },
	
	    drawYAxis: function drawYAxis(metric, left) {
	      if (metric === 'surfaces') {
	        // surfaces goes on the ele profile, not the y axis
	        return;
	      }
	      var metricObj = this.metrics(metric);
	      var baseMetric = metricObj.baseMetricKey();
	      var right = left + this.yAxisWidth;
	      var onLeft = left < this.width() / 2;
	
	      var inverseConversionFn = metricObj.inverseConvert;
	      var tickValues = this.plotMetaData[metric].tickValues;
	      var numTicks = tickValues.length;
	
	      var min = this.plotMetaData[metric].min;
	      var max = this.plotMetaData[metric].max;
	
	      var outerTicksLength = 6;
	      var innerTicksLength = 4;
	      var lineSideMargin = 0;
	      var tickLabelMargin = 2;
	      var ctx = this.ctx;
	
	      var top = this.plotToPixel(null, max, metric);
	      var bottom = this.plotToPixel(null, min, metric);
	
	      // use the same code to draw left or right side yaxis, basically just mirroring it with these vars
	      var verticalLineXOffset = onLeft ? right - lineSideMargin : left + lineSideMargin;
	      var tickDirectionMult = onLeft ? -1 : 1;
	
	      ctx.beginPath();
	      var strokeStyle = this.strokeStyle(baseMetric);
	      if (strokeStyle && metric != 'ele') {
	        // hack hack to make ele black black
	        ctx.strokeStyle = strokeStyle;
	        ctx.fillStyle = strokeStyle;
	      }
	
	      // axis line
	      ctx.moveTo(verticalLineXOffset, top);
	      ctx.lineTo(verticalLineXOffset, bottom);
	      // tick marks with labels
	      for (var i = 0; i < numTicks; i++) {
	        var convertedPlotVal = tickValues[i];
	        var plotVal = inverseConversionFn(convertedPlotVal);
	        var y;
	        if (metric != 'ele' && i == 0) // snap tick to bottom (except if ele -- its tightly labeled on bottom end)
	          y = bottom;else if (i == numTicks - 1) // snap tick to top
	          y = top;else // its an in-between tick so just draw it in the right place
	          y = this.plotToPixel(null, plotVal, metric);
	        var width = i == 0 || i == numTicks - 1 ? outerTicksLength : innerTicksLength;
	        var tickEndX = verticalLineXOffset + tickDirectionMult * width;
	        ctx.moveTo(verticalLineXOffset, y);
	        ctx.lineTo(tickEndX, y);
	        // label
	        var label = this.formatNumber(convertedPlotVal, metric);
	        this.placeText(label, tickEndX + tickDirectionMult * tickLabelMargin, y, { align: onLeft ? 'right' : 'left', vAlign: 'middle' });
	      }
	      // axis unit label
	      var axisLabelMargin = 5;
	      var bottomLabelSpaceFromLine = 3;
	      label = T.t('sample_graph.' + baseMetric) + '<br>(' + T.t('sample_graph.' + SG.unitsFor(baseMetric)) + ')';
	      this.placeText(label, verticalLineXOffset + tickDirectionMult * bottomLabelSpaceFromLine, bottom + axisLabelMargin, { align: onLeft ? 'right' : 'left' });
	
	      ctx.stroke();
	      ctx.restore();ctx.save();
	    },
	
	    clearBeforeRender: function clearBeforeRender() {
	      this.ctx.clearRect(0, 0, this.$canvas.width(), this.$canvas.height());
	      $('.' + this.uniqueClass + '.sample-graph-render-text').remove();
	    },
	
	    // This is not intended as a robust charting solution - it's for generating SVGs
	    // for use in ride posters. If you're thinking of using it for something else
	    // refactor it first.
	    makeSVG: function makeSVG(metric) {
	      var plotHeight = 200;
	      var plotWidth = 1000;
	      var padding = 75;
	      var data = this.dataToRender();
	      var xAxisType = 'distance';
	
	      var nice = function nice(a, rounding) {
	        if (a === 0) return 0;
	        var x = a;
	        // if x is negative, correct it
	        var negative = 1;
	        if (x < 0) {
	          x = x * -1;
	          negative = -1;
	        }
	        // get order of magnitude
	        var bigness = Math.pow(10, Math.floor(Math.log10(x)));
	        // convert to an value in the range (0, 10)
	        var i = x / bigness;
	        // round to a multiple of 0.5 or 5 depending on size
	        var round = i < 5 ? 0.5 : 5;
	        var j = Math[rounding](i / round);
	        // re-scale
	        return bigness * j * round * negative;
	      };
	      var xMetricObj = this.metrics(xAxisType);
	      var xNice = function xNice(x, rounding) {
	        return xMetricObj.inverseConvert(nice(xMetricObj.convert(x), rounding));
	      };
	      var xMin = xNice(data[0][xAxisType], 'floor');
	      var xMax = data[data.length - 1][xAxisType];
	      var xRatio = plotWidth / (xMax - xMin);
	
	      var yMetricObj = this.metrics(metric);
	      var yNice = function yNice(x, rounding) {
	        return yMetricObj.inverseConvert(nice(yMetricObj.convert(x), rounding));
	      };
	      var yMin = yNice(this.plotMetaData[metric].min, 'floor');
	      var yMax = yNice(this.plotMetaData[metric].max, 'ceil');
	      var yRatio = plotHeight / (yMax - yMin);
	
	      var node = function node(tag) {
	        return document.createElementNS("http://www.w3.org/2000/svg", tag);
	      };
	
	      var svg = node('svg');
	      var plot = node('path');
	
	      var xScale = function xScale(x) {
	        return x * xRatio;
	      };
	      var yScale = function yScale(y) {
	        return plotHeight - (y - yMin) * yRatio;
	      };
	
	      svg.setAttribute('width', plotWidth + 2 * padding);
	      svg.setAttribute('height', plotHeight + 2 * padding);
	
	      var scaledPoints = data.map(function (point) {
	        var x = xScale(point[xAxisType]);
	        var y = yScale(point[metric]);
	        return x + ',' + y;
	      });
	      var points = ['0,' + plotHeight].concat(_toConsumableArray(scaledPoints), [plotWidth + ',' + plotHeight]);
	      plot.setAttribute('d', 'M' + points.join('L') + 'Z');
	      plot.setAttribute("fill", '#ffb370');
	      plot.setAttribute("stroke", '#f70');
	      plot.setAttribute("stroke-width", 2);
	      plot.setAttribute("transform", 'translate(' + padding + ', ' + padding + ')');
	
	      var xAxisGroup = node('g');
	      xAxisGroup.setAttribute("transform", 'translate(' + padding + ',' + (padding + plotHeight + 10) + ')');
	      var xAxis = node('path');
	      xAxis.setAttribute('d', 'M0,0H' + plotWidth);
	      xAxis.setAttribute("stroke", '#bbb');
	      xAxis.setAttribute("stroke-width", 2);
	      xAxisGroup.appendChild(xAxis);
	
	      var xAxisLabels = node('g');
	      xAxisLabels.setAttribute("transform", 'translate(' + padding + ',' + (padding + plotHeight + 27) + ')');
	      xAxisLabels.setAttribute("style", 'fill: #bbb; font-family: Helvetica, sans-serif; font-size: 12px;');
	
	      var xInt = xNice((xMax - xMin) / 8, 'round'); // we want at least 8 tickmarks
	      for (var i = 0; i * xInt < xMax; i++) {
	        var x = xScale(xMin + xInt * i);
	        var tick = node('path');
	        tick.setAttribute("stroke", '#bbb');
	        tick.setAttribute("stroke-width", 2);
	        tick.setAttribute('transform', 'translate(' + x + ',0)');
	        tick.setAttribute('d', 'M0,0V5');
	        xAxisGroup.appendChild(tick);
	
	        var label = node('text');
	        var distance = this.metrics('distance').convert(xMin + xInt * i);
	        label.textContent = this.formatNumber(distance, 'distance');
	        label.setAttribute('transform', 'translate(' + x + ',0)');
	        label.setAttribute('text-anchor', 'middle');
	        xAxisLabels.appendChild(label);
	      }
	
	      var xAxisUnits = node('text');
	      xAxisUnits.textContent = 'distance (' + SG.unitsFor(xAxisType) + ')';
	      xAxisUnits.setAttribute('transform', 'translate(' + plotWidth / 2 + ',20)');
	      xAxisUnits.setAttribute('text-anchor', 'middle');
	      xAxisLabels.appendChild(xAxisUnits);
	
	      var yAxisGroup = node('g');
	      yAxisGroup.setAttribute("transform", 'translate(' + (padding - 10) + ',' + padding + ')');
	      var yAxis = node('path');
	      yAxis.setAttribute('d', 'M0,0V' + plotHeight);
	      yAxis.setAttribute("stroke", '#bbb');
	      yAxis.setAttribute("stroke-width", 2);
	      yAxisGroup.appendChild(yAxis);
	
	      var yAxisLabels = node('g');
	      yAxisLabels.setAttribute("transform", 'translate(' + (padding - 18) + ',' + (padding + 4) + ')');
	      yAxisLabels.setAttribute("style", 'fill: #bbb; font-family: Helvetica, sans-serif; font-size: 12px;');
	
	      // calculate the distance between tick marks by rounding 1/4 of the range
	      // of the data to the nearest multiple of 1, 5, or 10
	      var yInt = (yMax - yMin) / 4;
	      for (var _i = 0; _i <= 4; _i++) {
	        var y = yScale(yMin + yInt * _i);
	        var _tick = node('path');
	        _tick.setAttribute("stroke", '#bbb');
	        _tick.setAttribute("stroke-width", 2);
	        _tick.setAttribute('transform', 'translate(0,' + y + ')');
	        _tick.setAttribute('d', 'M0,0H-5');
	        yAxisGroup.appendChild(_tick);
	
	        var _label = node('text');
	        var m = this.metrics(metric).convert(yMin + yInt * _i);
	        _label.textContent = this.formatNumber(m, metric);
	        _label.setAttribute('transform', 'translate(0,' + y + ')');
	        _label.setAttribute('text-anchor', 'end');
	        yAxisLabels.appendChild(_label);
	      }
	
	      var yAxisUnits = node('text');
	      yAxisUnits.textContent = 'elevation (' + SG.unitsFor(metric) + ')';
	      yAxisUnits.setAttribute('transform', 'translate(-40,' + plotHeight / 2 + ') rotate(90)');
	      yAxisUnits.setAttribute('text-anchor', 'middle');
	      yAxisLabels.appendChild(yAxisUnits);
	
	      svg.appendChild(plot);
	      svg.appendChild(xAxisGroup);
	      svg.appendChild(xAxisLabels);
	      svg.appendChild(yAxisGroup);
	      svg.appendChild(yAxisLabels);
	      return svg;
	    },
	
	    unpavedPattern: function unpavedPattern() {
	      if (this._unpavedPatternCanvas) {
	        return this._unpavedPatternCanvas;
	      }
	
	      var patternCanvas = document.createElement('canvas');
	      var patternContext = patternCanvas.getContext('2d');
	
	      patternCanvas.width = 10;
	      patternCanvas.height = 5;
	
	      patternContext.fillStyle = '#FAEFEE';
	      patternContext.fillRect(0, 0, 4, patternCanvas.height);
	      patternContext.fillStyle = '#cf635a';
	      patternContext.fillRect(4, 0, patternCanvas.width, patternCanvas.height);
	      patternContext.stroke();
	
	      this._unpavedPatternCanvas = patternCanvas;
	      return this._unpavedPatternCanvas;
	    },
	
	    // draw indicated plot only
	    drawPlot: function drawPlot(metric) {
	      if (metric === 'surfaces') {
	        // surfaces is drawn by ele
	        return;
	      }
	
	      var ctx = this.ctx,
	          width = this.plotWidth,
	          data = this.dataToRender(),
	          len = data.length,
	          xAxisType = this.xAxisType(),
	          xMin = data[0][xAxisType],
	          xMax = data[len - 1][xAxisType],
	          xRatio = width / (xMax - xMin),
	          strokeStyle = this.strokeStyle(metric),
	          filters = this.filters(),
	          fillStyle = this.fillStyle(metric);
	      this.xRatio = isFinite(xRatio) ? xRatio : 0;
	      this.xMin = xMin;
	
	      // if we're drawing pen is down, draw lines.  otherwise pen is up, so moveto
	      var drawing = false;
	      var filter = filters[metric];
	      var bottom = this.plotMargin().top + this.plotHeight;
	      var startX;
	      var x, y;
	      var closePath = function closePath() {
	        ctx.lineTo(x, y);
	        if (fillStyle) {
	          ctx.lineTo(x, bottom);
	          ctx.lineTo(startX, bottom);
	          ctx.fillStyle = fillStyle;
	          ctx.fill();
	        }
	        ctx.strokeStyle = strokeStyle;
	        ctx.stroke();
	        ctx.closePath();
	      };
	      for (var i = 0; i < len; i++) {
	        var dCurr = data[i][metric];
	        if (dCurr === undefined || dCurr === null || filter && !filter(dCurr)) {
	          // if there is a fill style, we don't want to quit drawing.
	          // instead, we'll draw a straight line to the next point.
	          if (drawing && !fillStyle) {
	            closePath();
	            drawing = false;
	          }
	          continue;
	        }
	        x = this.plotToPixel(data[i][xAxisType]);
	        y = this.plotToPixel(null, dCurr, metric);
	
	        if (metric === 'ele') {
	          if (data[i].excludeFromMetrics && (i === 0 || !data[i - 1].excludeFromMetrics)) {
	            // beginning a section of elevation that is excluded from metrics, it will show up grey.
	            // fill in the elevation profile up to this point, then start the excluded section
	            if (i > 0) closePath();
	            fillStyle = this.fillStyle('excluded');
	            strokeStyle = this.strokeStyle('excluded');
	            drawing = false;
	          } else if (i < len - 1 && data[i].excludeFromMetrics && !data[i + 1].excludeFromMetrics) {
	            // ending a section of elevation that is excluded from metrics. revert to standard elevation styling
	            // after filling in the grey excluded section
	            closePath();
	            if (this.showSurface()) {
	              var surfaceGroups = rwgps.surfaces && rwgps.surfaces.surfaceGroups;
	              var group = surfaceGroups[data[i].surface];
	              fillStyle = this.fillStyle(group);
	            } else {
	              fillStyle = this.fillStyle('ele');
	            }
	            strokeStyle = this.strokeStyle('ele');
	            drawing = false;
	          } else if (!data[i].excludeFromMetrics && this.showSurface()) {
	            // this is handled last so that excluded style takes prescedence
	            var _surfaceGroups = rwgps.surfaces && rwgps.surfaces.surfaceGroups;
	            var lastGroup = data[i - 1] && _surfaceGroups[data[i - 1].surface];
	            var _group = data[i] && _surfaceGroups[data[i].surface];
	
	            if (lastGroup && _group !== lastGroup || i === 0) {
	              if (i > 0) closePath();
	              fillStyle = this.fillStyle(_group);
	              strokeStyle = this.strokeStyle('ele');
	              drawing = false;
	            }
	          }
	        }
	
	        if (!drawing) {
	          startX = x;
	          ctx.beginPath();
	          ctx.moveTo(x, y);
	          drawing = true;
	        } else {
	          ctx.lineTo(x, y);
	        }
	      }
	      if (drawing) {
	        closePath();
	      }
	      ctx.restore();ctx.save();
	    }
	  });
	})(SampleGraph, window);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	* Interaction behavior for Sample Graph
	*
	* Features:
	*   - Highlight point on mouse over
	*   - Drag-select series of data
	*   - Click-select individual point
	*
	* Triggers these events on graph object:
	*   - pointselected(i)
	*   - segmentselected(dataSlice)
	*   - mousedown(e)
	*   - mouseover(e)
	*   - mousemove(canvasX, canvasY, e)
	*   - mouseout(e)
	*   - verticalmouseout(e)
	*
	* Not required if user interaction is not desired.
	*/
	
	(function (SG, window) {
	  SG.registerModule('interaction');
	  SG.bind('initialize:after', function (graph) {
	    _.bindAll(graph, 'highlightPointUnderMouse', 'onMouseOut', 'beginDragSelect', 'switchToTimeXAxis', 'switchToDistanceXAxis', 'setDragBehaviorToZoomIn');
	    graph.$body = $('body');
	    // this is a fancy global page thing that helps the graph trigger mouseover/mousemove/mouseout 
	    graph.setupMouseMove();
	    // mousedown can originate from the canvas element, or the floating hover line. 
	    // the hover line gets created/removed periodically, so here's how we consolidate those mousedown events
	    graph.$canvas.mousedown(function (e) {
	      if (e.button === 0) graph.trigger('mousedown', e);
	    });
	    graph.bindTo(graph, 'hoverEl:created', function () {
	      graph.$hoverElHorizontal.mousedown(function (e) {
	        if (e.button === 0) graph.trigger('mousedown', e);
	      });
	      graph.$hoverElVertical.mousedown(function (e) {
	        if (e.button === 0) graph.trigger('mousedown', e);
	      });
	    });
	    // bind our default behavior
	    graph.bindMouseInteractions();
	    graph.bindTo(graph, 'zoom:in', graph.defaultMouseOutCleanup);
	    graph.bindTo(graph, 'zoom:out', graph.defaultMouseOutCleanup);
	    graph.bindTo(graph, 'render:after', graph.redrawOverlays);
	    graph.bindTo(graph, 'render:after', graph.bindEvents);
	    // when beginDragSelect is ran, it attaches a mouseup handler to
	    // <body>. jQuery doesn't let us control context, so let's permanently
	    // bind it to the graph context.
	    graph.completeDragSelect = _.bind(graph.completeDragSelect, graph);
	    // set default drag action
	    graph.setDragBehaviorToZoomIn();
	  });
	
	  SG.bind('unload_bindings:before', function (graph) {
	    // unload our click handlers
	    $('.sample-graph-render-text').off('click', '.sg-on-drag-zoom-in', graph.setDragBehaviorToZoomIn);
	    $('.sample-graph-render-text').off('click', '.sample-graph-x-axis-use-time', graph.switchToTimeXAxis);
	    $('.sample-graph-render-text').off('click', '.sample-graph-x-axis-use-distance', graph.switchToDistanceXAxis);
	  });
	
	  _.extend(SG.prototype, {
	    switchToTimeXAxis: function switchToTimeXAxis() {
	      this.xAxisType('time');
	      this.render();
	    },
	
	    switchToDistanceXAxis: function switchToDistanceXAxis() {
	      this.xAxisType('distance');
	      this.render();
	    },
	
	    disableDragBehavior: function disableDragBehavior() {
	      this.unbindFrom(this, 'mousedown', this.beginDragSelect);
	      $('.sg-zooming-tip').hide();
	    },
	    enableDragBehavior: function enableDragBehavior() {
	      this.bindTo(this, 'mousedown', this.beginDragSelect);
	      $('.sg-zooming-tip').show();
	    },
	    setDragBehaviorToZoomIn: function setDragBehaviorToZoomIn(e) {
	      if (!e || !$(e.target).hasClass("selected")) {
	        this.segmentselectedBehavior = 'zoom_in';
	        $('.sg-on-drag-zoom-in').addClass('selected');
	        $('.sg-on-drag-select-segment').removeClass('selected');
	        if (this._currentDragBehaviorFn) this.unbindFrom(this, 'segmentselected', this._currentDragBehaviorFn);
	        this._currentDragBehaviorFn = this.zoomToDataSlice;
	        this.bindTo(this, 'segmentselected', this._currentDragBehaviorFn);
	      }
	    },
	
	    identifySegment: function identifySegment(dataSlice) {
	      this.unidentifySegment();
	      var plotLeft = this.$canvas.offset().left + this.plotMargin().left,
	          plotRight = plotLeft + this.plotWidth,
	          firstPt = dataSlice.points(0),
	          lastPt = dataSlice.lastPoint(),
	          offset = this.$canvas.offset(),
	          left = offset.left + Math.round(this.plotToPixel(firstPt[this.xAxisType()])),
	          width = offset.left + Math.round(this.plotToPixel(lastPt[this.xAxisType()])) - left;
	      // totally out of bounds?
	      if (left > plotRight || left + width < plotLeft) return;
	      // partially out of bounds?
	      if (left < plotLeft) left = plotLeft;
	      if (left + width > plotRight) width = plotRight - left;
	
	      this._identifiedSegment = dataSlice;
	      this.$identifyOverlay = $('<div></div>').css({
	        position: 'absolute',
	        zIndex: this.zIndex(),
	        background: '#0000ff',
	        filter: 'alpha(opacity=30)',
	        opacity: 0.3
	      }).height(this.plotHeight).width(width).offset({ top: this.$canvas.offset().top + this.plotMargin().top, left: left }).prependTo('body');
	    },
	
	    unidentifySegment: function unidentifySegment() {
	      if (this.$identifyOverlay) {
	        this.$identifyOverlay.remove();
	        delete this.$identifyOverlay;
	        delete this._identifiedSegment;
	      }
	    },
	
	    enableMouseInteractions: function enableMouseInteractions() {
	      this._mouseInteractionsDisabled = false;
	    },
	
	    disableMouseInteractions: function disableMouseInteractions() {
	      this._mouseInteractionsDisabled = true;
	    },
	
	    unbindMouseInteractions: function unbindMouseInteractions() {
	      if (!this._mouseInteractionsBound) return;
	      this._mouseInteractionsBound = false;
	      this.unbindFrom(this, 'mousemove', this.highlightPointUnderMouse);
	      this.unbindFrom(this, 'mouseout', this.onMouseOut);
	      this.unbindFrom(this, 'mousedown', this.beginDragSelect);
	    },
	
	    bindMouseInteractions: function bindMouseInteractions() {
	      if (this._mouseInteractionsBound) return;
	      if (SG.isModuleLoaded('playback') && (this.isPlaying() || this.isPaused())) return;
	      this._mouseInteractionsBound = true;
	      this.bindTo(this, 'mousemove', this.highlightPointUnderMouse);
	      this.bindTo(this, 'mouseout', this.onMouseOut);
	      this.bindTo(this, 'mousedown', this.beginDragSelect);
	    },
	
	    // takes page coords
	    inPlotBounds: function inPlotBounds(x, y) {
	      var graphOffset = this.$canvas.offset(),
	          plotMargin = this.plotMargin(),
	          plotOffset = { top: graphOffset.top + plotMargin.top, left: graphOffset.left + plotMargin.left };
	      return x > plotOffset.left && x < plotOffset.left + this.plotWidth && y > plotOffset.top && y < plotOffset.top + this.plotHeight;
	    },
	
	    onMouseOut: function onMouseOut() {
	      this.defaultMouseOutCleanup();
	    },
	
	    // Attach a mousemove handler on window that only highlights points if the mouse is over the plot area.
	    //
	    // Adding it to window instead of the canvas element because labels and other things might appear over the canvas 
	    // and get in the way. Also, this makes it easy to remove the hover element when the mouse leaves the plot area.
	    setupMouseMove: function setupMouseMove() {
	      var that = this;
	      this.bindTo(this.$body, 'mousemove', _.throttle(function (e) {
	        if (that._mouseInteractionsDisabled) return;
	        var graphOffset = that.$canvas.offset(),
	            plotMargin = that.plotMargin(),
	            plotOffset = { top: graphOffset.top + plotMargin.top, left: graphOffset.left + plotMargin.left };
	        // if mouse is in plot bounds, highlight position.  otherwise, hide highlight stuff if its showing
	        if (that.inPlotBounds(e.pageX, e.pageY) && !that.inBoundsOfControl(e.pageX, e.pageY)) {
	          var canvasCoords = that.eventToCanvasCoords(e, graphOffset);
	          if (!that.mouseCurrentlyOver) {
	            that.trigger('mouseover', e);
	            that.mouseCurrentlyOver = true;
	            that.mouseStillVerticallyOver = true;
	          }
	          that.trigger('mousemove', canvasCoords.x, canvasCoords.y, e);
	        } else {
	          if (that.mouseCurrentlyOver) {
	            that.mouseCurrentlyOver = false;
	            that.trigger('mouseout', e);
	          }
	          // we have a more specific event, verticalmouseout, that
	          // fires when the mouse y position gets off the graph,
	          // but we ignore x and pretend the graph extends forever
	          // horizontally. this allows easily drag-selecting all the
	          // way to the first or last point
	          if (that.mouseStillVerticallyOver && !(e.pageY > plotOffset.top && e.pageY < plotOffset.top + that.plotHeight)) {
	            that.mouseStillVerticallyOver = false;
	            that.trigger('verticalmouseout', e);
	          }
	        }
	      }, 20));
	    },
	
	    highlightPointUnderMouse: function highlightPointUnderMouse(x) {
	      // default, just highlight the point we're over
	      if (this.dataToRender().length == 0) return;
	      var pointsAroundX = this.canvasXToDataI(x);
	      this.highlightPoint(pointsAroundX);
	      this.trigger('highlight_at_position', pointsAroundX);
	    },
	
	    highlightPoint: function highlightPoint(pointsAroundX) {
	      var point = pointsAroundX.estimatedPoint;
	      rwgps.Events.trigger('sg:highlightPoint', pointsAroundX);
	      this.highlightPointAtX(point, pointsAroundX.x);
	      this.showPointDetails(point, pointsAroundX.x);
	    },
	
	    highlightPointByIndex: function highlightPointByIndex(i, showPointDetails, segmentSelectorIndex) {
	      if (this.dataToRender() && i > this.dataToRender().length) {
	        return;
	      }
	      if (segmentSelectorIndex) {
	        i += this.segmentSelector.dataSlice.i - this.zoomedSlice().i;
	      }
	      var pt = this.dataToRender()[i],
	          x = this.plotToPixel(pt[this.xAxisType()]);
	      this.highlightPointAtX(pt, x);
	      if (showPointDetails) {
	        this.showPointDetails(pt, x);
	      }
	    },
	
	    // given a canvas x coord, will highlight the point at that position
	    highlightPointAtX: function highlightPointAtX(nearestPoint, x) {
	      // they are always created together so only need to check for one of them
	      if (!this.$hoverElVertical) {
	        this.$hoverElVertical = $('<div></div>').addClass('sg-elem').addClass('sg-hover').addClass('sg-hover-vertical-line').css({ zIndex: this.zIndex() }).height(this.plotHeight).prependTo(this.$canvas.parent());
	        this.$hoverElHorizontal = $('<div></div>').addClass('sg-elem').addClass('sg-hover').addClass('sg-hover-horizontal-line').css({ zIndex: this.zIndex() }).width(this.plotWidth).prependTo(this.$canvas.parent());
	        this.$hoverXLabel = $('<span></span>').addClass('sg-elem').addClass('sg-hover').addClass('sg-hover-x-label').css({ zIndex: this.zIndex() }).prependTo(this.$canvas.parent());
	        this.trigger('hoverEl:created');
	      }
	      this._pointHighlighted = {
	        point: nearestPoint,
	        x: x
	      };
	      this.repositionPointHighlight();
	      return nearestPoint;
	    },
	
	    repositionPointHighlight: function repositionPointHighlight() {
	      var metric = this.primaryMetric();
	      if (!this._pointHighlighted || !this.$hoverElVertical || !metric) return;
	      var y = this.plotToPixel(null, this._pointHighlighted.point[metric.key()], metric.key());
	      var offset = this.$canvas.offset();
	      this.$hoverElVertical.offset({ top: offset.top + this.plotMargin().top, left: offset.left + this._pointHighlighted.x });
	      this.$hoverElHorizontal.offset({ top: offset.top + y, left: offset.left + this.plotMargin().left });
	      var xAxisType = this.xAxisType();
	      var label = this.formatNumber(this.metrics(xAxisType).convert(this._pointHighlighted.point[xAxisType]), xAxisType, true);
	      this.$hoverXLabel.html(label);
	      this.$hoverXLabel.offset({ top: offset.top + this.plotMargin().top + this.plotHeight, left: offset.left + this._pointHighlighted.x - this.$hoverXLabel.outerWidth() / 2 });
	    },
	
	    // presumably the mouse has just gone down, and its time to enter
	    // drag-select mode. we'll visually show the user what they are
	    // selecting, and once the mouse comes back up we'll trigger an event
	    beginDragSelect: function beginDragSelect(e) {
	      if (this._mouseInteractionsDisabled) return;
	      if (this.dataToRender().length == 0) return;
	      // this only happens when you drag out of a window then mouseup
	      // before coming back and screw up our state... if that happens
	      // just cancel it 
	      if (this.dragging) {
	        this.endDragSelect();
	        return;
	      }
	      // cancel out any text selections
	      document.body.focus();
	      // prevent text selection in IE
	      document.onselectstart = function () {
	        return false;
	      };
	
	      // prevent stuff on the page from getting selected during drag
	      e.preventDefault();
	      // alright we're dragging, lets keep track of our state in here
	      this.dragging = {
	        $overlay: null,
	        startX: this.eventToCanvasCoords(e).x
	        // create the cool selection overlay
	      };this.dragging.$overlay = $('<div class="sg-segment-selector-control"></div>').css({
	        zIndex: this.zIndex(),
	        background: 'black',
	        filter: 'alpha(opacity=50)',
	        opacity: 0.5,
	        position: 'absolute'
	      }).offset({ top: this.$canvas.offset().top + this.plotMargin().top }).height(this.plotHeight).prependTo(this.$canvas.parent());
	
	      // the default interaction of highlighting points on mousemove
	      // is cool so we arent going to remove it, just bind some extra
	      // behavior for visualizing/cancelling/completing the select
	      this.bindTo(this, 'mousemove', this.adjustSelection);
	      this.bindTo(this, 'mouseout', this.dragSelectMouseOut);
	      this.bindTo(this, 'verticalmouseout', this.cancelDragSelect);
	      // have to bind it to window to catch mouseup events outside browser viewport 
	      this.bindTo($(window), 'mouseup', this.completeDragSelect);
	      this.trigger('dragselect:begin');
	    },
	
	    // if the mouse is off to the left or right, snap the selection there
	    dragSelectMouseOut: function dragSelectMouseOut(e) {
	      var coords = this.eventToCanvasCoords(e),
	          leftSide = this.plotMargin().left,
	          rightSide = leftSide + this.plotWidth;
	      if (coords.x <= leftSide) this.adjustSelection(leftSide);else {
	        // if i dont add one here it only selects until one pixel
	        // before the very end
	        this.adjustSelection(rightSide + 1);
	      }
	    },
	
	    adjustSelection: function adjustSelection(x) {
	      // just adjust the dragSelectOverlay - the width is how far away from where we started, and the position is based on whether we're to the left or right
	      var displacement = x - this.dragging.startX,
	          left;
	      if (displacement < 0) {
	        // gone to the left of start position, so left side of overlay
	        // is where the mouse is. need to add a pixel to make the
	        // filled area cover the full range selected.
	        left = this.canvasToPageCoords(x) + 1;
	      } else {
	        // gone to the right, so leave the left side of the overlay at the start of the drag
	        left = this.canvasToPageCoords(this.dragging.startX);
	      }
	      // width is just |displacement| in our 1 dimensional world
	      this.dragging.$overlay.width(Math.abs(displacement)).offset({ top: this.$canvas.offset().top + this.plotMargin().top, left: left });
	    },
	
	    // whether cancelled or completed, when dragSelect is done with we
	    // need to unbind its events and clean up its associated data/dom element
	    endDragSelect: function endDragSelect() {
	      this.dragging.$overlay.remove();
	      delete this.dragging;
	      // undo our text selection prevention for IE
	      document.onselectstart = null;
	      this.unbindFrom(this, 'mousemove', this.adjustSelection);
	      this.unbindFrom(this, 'verticalmouseout', this.cancelDragSelect);
	      this.unbindFrom(this, 'mouseout', this.dragSelectMouseOut);
	      this.unbindFrom($(window), 'mouseup', this.completeDragSelect);
	      this.trigger('dragselect:end');
	    },
	
	    cancelDragSelect: function cancelDragSelect() {
	      this.endDragSelect();
	    },
	
	    // moused up in the plot area after mousing down... this could
	    // just be a click though, so check for that before we declare a
	    // segment has been selected
	    completeDragSelect: function completeDragSelect(e) {
	      var endPosition = this.eventToCanvasCoords(e),
	          startX = this.dragging.startX,
	          displacement = endPosition.x - startX;
	      this.endDragSelect();
	      // with a 1 pixel epsilon, call this a pointselected event instead of a segmentselected
	      if (Math.abs(displacement) <= 1) {
	        var pointsAround = this.canvasXToDataI(startX);
	        this.trigger('pointselected', pointsAround);
	      } else {
	        // otherwise, we've got ourselves a segmentselected 
	        var firstX = displacement < 0 ? endPosition.x : startX,
	            firstI = this.canvasXToDataI(firstX).closestI,
	            lastI = this.canvasXToDataI(firstX + Math.abs(displacement)).closestI;
	        if (lastI - firstI > 1) {
	          var dataSlice = this.dataSlice(firstI, 1 + lastI - firstI);
	          this.trigger('segmentselected', dataSlice);
	        }
	      }
	    },
	
	    defaultMouseOutCleanup: function defaultMouseOutCleanup() {
	      // get rid of the hoverline if its there
	      if (this.$hoverElHorizontal) {
	        this.$hoverElHorizontal.remove();delete this.$hoverElHorizontal;
	      }
	      if (this.$hoverElVertical) {
	        this.$hoverElVertical.remove();delete this.$hoverElVertical;
	      }
	      if (this.$hoverMetrics) {
	        this.$hoverMetrics.remove();delete this.$hoverMetrics;
	      }
	      if (this.$hoverXLabel) {
	        this.$hoverXLabel.remove();delete this.$hoverXLabel;
	      }
	      delete this._pointHighlighted;
	    },
	
	    // render, position, populate the hover box
	    // right now we're just handing it the nearest point, but we're
	    // going to want to interpolate that shit based on this x, threw
	    // it in asana
	    showPointDetails: function showPointDetails(point, x) {
	      if (!this.$hoverMetrics) {
	        this.$hoverMetrics = $('<div></div>').addClass('sg-elem').addClass('sg-hover-details').css({ zIndex: this.zIndex() }).prependTo(this.$canvas.parent());
	        _.each(this.metricsKeysY(), function (metric) {
	          if (metric === 'grade') return; // displayed in ele
	          if (metric === 'surfaces' && !this.showSurface()) return;
	          this.$hoverMetrics.append('<span class="sg-metric sg-' + metric + '"></span><br />');
	        }, this);
	      }
	      // lets remember the width and let it get wider, but not
	      // narrower... too jarring to bounce back and forth in width and
	      // this is the laziest way to calculate max width
	      var minWidth = this.$hoverMetrics.width();
	
	      // populate with metrics
	      this.$hoverMetrics.find('.metric').hide();
	      var metricUnits = rwgps.LabelMaker.metric;
	      _.each(this.metricsY(), function (metric) {
	        var key = metric.key();
	        var value = point[this.metricVariationInUse(key)];
	        if (_.isNumber(value)) {
	          var html;
	          switch (key) {
	            case 'ele':
	              html = [Math.round(rwgps.Convert.mToShort(value)), metricUnits ? ' ' + T.t('sample_graph.m') : ' ' + T.t('sample_graph.ft')];
	              if (point.grade) html.push(' (', point.grade.toFixed(1), T.t('sample_graph.percent'), ')');
	              break;
	            case 'grade':
	              return; // displayed alongside ele already
	            case 'speed':
	              html = [metric.convert(value).toFixed(1), metricUnits ? ' ' + T.t('sample_graph.kph') : ' ' + T.t('sample_graph.mph')];
	              break;
	            default:
	              html = [Math.round(metric.convert(value)), ' ', T.t('sample_graph.' + SG.unitsFor(key))];
	              break;
	          }
	        } else if (this.showSurface()) {
	          // since 'surfaces' is not included in metricsY, do it separately
	          html = [rwgps.surfaces.surfaceGroups[point.surface], ' ', T.t('sample_graph.surface')];
	        } else {
	          html = [];
	        }
	        this.$hoverMetrics.find('.sg-metric.sg-' + key).html(html.join('')).show();
	        if (key === 'surfaces' && this.$hoverMetrics.find('.sg-surfaces').width() > this.$hoverMetrics.width()) {
	          // if the surface changes, it's possible for the new label to grow.
	          // if that's the case, let's make some more room!
	          this.$hoverMetrics.width(this.$hoverMetrics.find('.sg-surfaces').width());
	        }
	      }, this);
	      if (this.$hoverMetrics.width() < minWidth) this.$hoverMetrics.width(minWidth);
	      this._pointHighlighted = {
	        point: point,
	        x: x
	      };
	      this.repositionPointDetails();
	    },
	
	    bindEvents: function bindEvents() {
	      $('.sample-graph-render-text').on('click', '.sg-on-drag-zoom-in', this.setDragBehaviorToZoomIn);
	      $('.sample-graph-render-text').on('click', '.sample-graph-x-axis-use-time', this.switchToTimeXAxis);
	      $('.sample-graph-render-text').on('click', '.sample-graph-x-axis-use-distance', this.switchToDistanceXAxis);
	    },
	
	    redrawOverlays: function redrawOverlays() {
	      // if the graph has just been hidden, get rid of all our
	      // floating elements and dont do anything else
	      if (this.$canvas.is(':hidden')) {
	        $('.sg-elem').remove();
	        // unbind global listeners
	        this.unbindMouseInteractions();
	        return;
	      } else {
	        // rebind if necessary
	        this.bindMouseInteractions();
	      }
	      // if x-axis changes, need to figure out what x offset is for new
	      // position of highlighted point.  also repositions point details
	      // and point highlight (crosshairs).
	      if (this._pointHighlighted) {
	        var point = this._pointHighlighted.point;
	        this.defaultMouseOutCleanup();
	        this._pointHighlighted = {
	          point: point,
	          x: this.plotToPixel(point[this.xAxisType()])
	        };
	        this.highlightPointAtX(this._pointHighlighted.point, this._pointHighlighted.x);
	        this.showPointDetails(this._pointHighlighted.point, this._pointHighlighted.x);
	      }
	      if (this.$zoomingTip) {
	        this.$zoomingTip.remove();
	        delete this.$zoomingTip;
	      }
	      this.updateZoomingTip();
	
	      if (this._identifiedSegment) this.identifySegment(this._identifiedSegment);
	    },
	
	    updateZoomingTip: function updateZoomingTip() {
	      // create node if doesn't exist
	      if (!this.$zoomingTip) {
	        this.$zoomingTip = $('<span></span>').addClass(this.uniqueClass).addClass('sg-elem').addClass('sg-zooming-tip').css({ zIndex: this.zIndex() }).prependTo(this.$canvas.parent());
	      }
	      // populate with appropriate tip
	      if (this.zoomedIn()) {
	        if (this.options.extendedSelectionOptions) {
	          this.$zoomingTip.html(['<a href="javascript:;" class="sg-select-segment sg-bold">', T.t('sample_graph.select_segment'), '</a> ', T.t('sample_graph.click_to_zoom_out')].join(''));
	        } else {
	          this.$zoomingTip.html(T.t('sample_graph.click_to_zoom_out'));
	        }
	      } else {
	        if (this.options.extendedSelectionOptions) {
	          this.$zoomingTip.html([T.t('sample_graph.on_drag'), ' <a href="javascript:;" class="sg-on-drag-zoom-in">', T.t('sample_graph.zoom_in'), '</a> <a href="javascript:;" class="sg-on-drag-select-segment">', T.t('sample_graph.select_segment'), '</a>'].join(''));
	          $(this.segmentselectedBehavior == 'zoom_in' ? '.sg-on-drag-zoom-in' : '.sg-on-drag-select-segment').addClass("selected");
	        } else {
	          this.$zoomingTip.html(T.t('sample_graph.drag_to_zoom_in'));
	        }
	      }
	      // position it in the lower right
	      var offset = this.$canvas.offset();
	      var rightMargin = 10 + this.plotMargin().right,
	          bottomMargin = 8;
	      this.$zoomingTip.offset({ left: offset.left + this.$canvas.width() - this.$zoomingTip.width() - rightMargin,
	        top: offset.top + this.$canvas.height() - this.$zoomingTip.height() - bottomMargin });
	    },
	
	    // we need to get x from the point if the x-axis changes
	    repositionPointDetails: function repositionPointDetails() {
	      if (!this._pointHighlighted || !this.$hoverMetrics) return;
	      var height = 75;
	      var offset = this.$canvas.offset();
	      var topMargin = this.plotHeight > height ? (this.plotHeight - height) / 2 : 0;
	      var leftMargin = 15;
	      var buffer = 20;
	      if (this.$hoverMetrics.width() + this._pointHighlighted.x + leftMargin + buffer > this.$canvas.width()) {
	        // show on left
	        this.$hoverMetrics.offset({ top: offset.top + this.plotMargin().top + topMargin,
	          left: offset.left + this._pointHighlighted.x - leftMargin - this.$hoverMetrics.outerWidth() });
	      } else {
	        this.$hoverMetrics.offset({ top: offset.top + this.plotMargin().top + topMargin,
	          left: offset.left + this._pointHighlighted.x + leftMargin });
	      }
	    },
	
	    // mousemove calls this repeatedly and already has graphOffset handy, so letting it get passed in optionally
	    eventToCanvasCoords: function eventToCanvasCoords(e, graphOffset) {
	      if (!graphOffset) graphOffset = this.$canvas.offset();
	      var canvasX = e.pageX - graphOffset.left,
	          canvasY = e.pageY - graphOffset.top;
	      return { x: canvasX, y: canvasY };
	    },
	
	    // works like plotToPixel in that x and y are optional
	    canvasToPageCoords: function canvasToPageCoords(x, y) {
	      var graphOffset = this.$canvas.offset(),
	          pageX,
	          pageY;
	      if (x || x == 0) pageX = x + graphOffset.left;
	      if (y || y == 0) pageY = y + graphOffset.top;
	      if (!x && x != 0) return pageY;
	      if (!y && y != 0) return pageX;
	      return { x: pageX, y: pageY };
	    }
	  });
	})(SampleGraph, window);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	* Bindings to/from map for highlighting points and segments
	*
	*/
	
	(function (SG) {
	  SG.registerModule('map_bindings');
	  SG.bind('initialize:after', function (graph) {
	    if (Routes && Routes.activeMap) {
	      graph.initializeMapBindings();
	    } else {
	      graph._mapBindingsDisabled = true;
	    }
	  });
	
	  _.extend(SG.prototype, {
	    initializeMapBindings: function initializeMapBindings() {
	      this._onMapHighlightPoint = _.bind(this.onMapHighlightPoint, this);
	      this._onMapUnHighlightPoint = _.bind(this.onMapUnhighlightPoint, this);
	      this.bindTo(this, 'highlight_at_position', this.highlightPositionOnMap);
	      this.bindTo(this, 'mouseout', this.unhighlightPositionOnMap);
	      this.bindZoomWithMap();
	      this.bindTo(this, 'dataslice:select', this.highlightDataSliceOnMap);
	      this.bindTo(rwgps.Events, 'map:highlight_point', this._onMapHighlightPoint);
	      this.bindTo(rwgps.Events, 'map:unhighlight_nearest_point', this._onMapUnHighlightPoint);
	    },
	
	    removeMapBindings: function removeMapBindings() {
	      this.unbindFrom(this, 'highlight_at_position', this.highlightPositionOnMap);
	      this.unbindFrom(this, 'mouseout', this.unhighlightPositionOnMap);
	      this.unbindZoomWithMap();
	      this.unbindFrom(this, 'dataslice:select', this.highlightDataSliceOnMap);
	      this.unbindFrom(rwgps.Events, 'map:highlight_point', this._onMapHighlightPoint);
	      this.unbindFrom(rwgps.Events, 'map:unhighlight_nearest_point', this._onMapUnhighlightPoint);
	    },
	
	    bindZoomWithMap: function bindZoomWithMap() {
	      this.bindTo(this, 'zoom:in', this.highlightDataSliceOnMap);
	      this.bindTo(this, 'zoom:out', this.onZoomOutUnhighlightOnMap);
	    },
	
	    disableMapHighlighting: function disableMapHighlighting() {
	      if (!this.mapHighlightingDisabled && !this._mapBindingsDisabled) {
	        this.unbindZoomWithMap();
	        this.bindTo(this, 'zoom:in', this.zoomToDataSliceOnMap);
	        this.bindTo(this, 'zoom:out', this.recenterMap);
	        this.mapHighlightingDisabled = true;
	      }
	    },
	
	    enableMapHighlighting: function enableMapHighlighting() {
	      if (this.mapHighlightingDisabled && !this._mapBindingsDisabled) {
	        this.unbindFrom(this, 'zoom:in', this.zoomToDataSliceOnMap);
	        this.unbindFrom(this, 'zoom:out', this.recenterMap);
	        this.bindZoomWithMap();
	        this.mapHighlightingDisabled = false;
	      }
	    },
	
	    // this is the best way to "unhighlight" points on the map, because it gives control back
	    // to the graph (which might have a zoomed slice or selected segment it wants to highlight
	    revertMapHighlightedPoints: function revertMapHighlightedPoints() {
	      if (this.segmentSelector) {
	        // selected segment gets precedence over zoomed slice
	        this.highlightDataSliceOnMap(this.segmentSelector.dataSlice, true);
	      } else if (this.zoomedSlice()) {
	        this.highlightDataSliceOnMap(this.zoomedSlice(), true);
	      } else {
	        rwgps.unhighlightPoints(true);
	      }
	    },
	
	    unbindZoomWithMap: function unbindZoomWithMap() {
	      this.unbindFrom(this, 'zoom:in', this.highlightDataSliceOnMap);
	      this.unbindFrom(this, 'zoom:out', this.onZoomOutUnhighlightOnMap);
	    },
	
	    highlightPositionOnMap: function highlightPositionOnMap(pointsAroundPosition) {
	      rwgps.highlightPoint(pointsAroundPosition.highI, pointsAroundPosition.pct);
	    },
	
	    showMarker: function showMarker(lng, lat, id) {
	      rwgps.showMarker(lng, lat, id);
	    },
	
	    removeMarker: function removeMarker(id) {
	      rwgps.removeMarker(id);
	    },
	
	    unhighlightPositionOnMap: function unhighlightPositionOnMap() {
	      Routes.activeMap.unhighlightNearestPoint();
	    },
	
	    zoomToDataSliceOnMap: function zoomToDataSliceOnMap(dataSlice) {
	      rwgps.zoomToPoints(dataSlice.i, dataSlice.i + dataSlice.count);
	    },
	
	    recenterMap: function recenterMap() {
	      Routes.activeMap.recenterMap();
	    },
	
	    highlightDataSliceOnMap: function highlightDataSliceOnMap(dataSlice, dontChangeView, doSync) {
	      var doit = function doit() {
	        rwgps.highlightPoints(dataSlice.i, dataSlice.i + dataSlice.count, dontChangeView);
	      };
	      if (doSync) doit();else _.defer(doit);
	    },
	
	    onZoomOutUnhighlightOnMap: function onZoomOutUnhighlightOnMap() {
	      rwgps.unhighlightPoints();
	    },
	
	    onMapHighlightPoint: function onMapHighlightPoint(pointsAroundPosition) {
	      if (this.zoomedIn()) {
	        var i = pointsAroundPosition.closestI;
	        // if outside of zoom bounds, don't highlight!
	        var zoomedSlice = this.zoomedSlice();
	        if (i < zoomedSlice.i || i >= zoomedSlice.i + zoomedSlice.count) {
	          this.defaultMouseOutCleanup();
	          return;
	        }
	      }
	      var x = this.pointsAroundToX(pointsAroundPosition);
	      if (!x) return; // sometimes the map has data sooner than us
	      var closestPoint = this.data()[pointsAroundPosition.closestI];
	      this.highlightPointAtX(closestPoint, x);
	      this.showPointDetails(closestPoint, x);
	    },
	
	    onMapUnhighlightPoint: function onMapUnhighlightPoint() {
	      // dont unhighlight the point if we are currently moused over
	      // the plot
	      if (!this.mouseCurrentlyOver) {
	        this.defaultMouseOutCleanup();
	      }
	    }
	  });
	})(SampleGraph);

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	/* 
	 * Playback brought in almost directly from Flash so please excuse the non-idiomatic code
	 *
	 */
	
	(function (SG) {
	  SG.registerModule('playback');
	  SG.bind('initialize:after', function (graph) {
	    graph.loopPlay = _.bind(graph.loopPlay, graph);
	  });
	
	  _.extend(SG.prototype, {
	    playbackSpeed: 1.5,
	
	    setPlaybackSpeed: function setPlaybackSpeed(speed) {
	      this.playbackSpeed = speed;
	    },
	
	    highlightPointAtTime: function highlightPointAtTime(time) {
	      var pointsAround = this.pointsAroundX(time, 'time');
	      var x = this.pointsAroundToX(pointsAround);
	      var point = this.data()[pointsAround.closestI];
	      this.highlightPointAtX(point, x);
	      this.showPointDetails(point, x);
	      this.trigger('highlight_at_position', pointsAround);
	    },
	
	    setPlaybackPercentage: function setPlaybackPercentage(pct) {
	      var points = this.dataToRender();
	      if (!this._playing && !this._paused) {
	        this._paused = true;
	      }
	      var maxTime = points[points.length - 1]['time'];
	      if (!maxTime) maxTime = points[points.length - 2]['time'];
	
	      this._playHead = points[0]['time'] + pct * (maxTime - points[0]['time']) / 100.0;
	      this.highlightPointAtTime(this._playHead);
	    },
	
	    play: function play() {
	      if (this._playing) return;
	      var points = this.dataToRender();
	
	      if (!this._playHead || !this._paused) this._playHead = points[0]['time'];
	      this._playing = true;
	      this._paused = false;
	      this.unbindMouseInteractions();
	      this.loopPlay();
	    },
	
	    isPlaying: function isPlaying() {
	      return this._playing;
	    },
	    isPaused: function isPaused() {
	      return this._paused;
	    },
	
	    loopPlay: function loopPlay() {
	      if (!this._playing) return;
	
	      var points = this.dataToRender();
	
	      var maxTime = points[points.length - 1]['time'];
	      if (!maxTime) maxTime = points[points.length - 2]['time'];
	      if (this._playHead < maxTime) {
	        this.highlightPointAtTime(this._playHead);
	        this._playHead += this.playbackSpeed;
	        setTimeout(this.loopPlay, 40);
	      } else {
	        this._playing = false;
	      }
	    },
	
	    pause: function pause() {
	      this._playing = false;
	      this._paused = true;
	    },
	
	    stopPlayback: function stopPlayback() {
	      this._playing = this._paused = false;
	      this.bindMouseInteractions();
	    }
	
	  });
	  SG.Playhead = function (data, uniqueId) {
	    var points = data.points();
	    this.uniqueId = uniqueId;
	    this._data = data;
	    this._points = points;
	    this.firstTime = points[0].time;
	    this.maxTime = points[points.length - 1].time || points[points.length - 2].time;
	    this.duration = this.maxTime - this.firstTime;
	  };
	  SG.Playhead.prototype = {
	    pointsAroundOffsetTime: function pointsAroundOffsetTime(time) {
	      var absTime = this.firstTime + time;
	      if (absTime <= this.maxTime) return this._data.pointsAroundX(absTime, 'time');else {
	        var ptsAround = this._data.pointsAroundX(this.maxTime, 'time');
	        ptsAround.pastEnd = true;
	        return ptsAround;
	      }
	    },
	    points: function points() {
	      return this._points;
	    }
	  };
	  SG.MultiTrackPlayhead = function (graph) {
	    this.graph = graph;
	    this._playheads = [];
	    this._currentTime = 0;
	    this.playbackSpeed = 1.6;
	    this._playing = false;
	    this._paused = false;
	    _.bindAll(this, 'loopPlay');
	  };
	  SG.MultiTrackPlayhead.prototype = {
	    addData: function addData(data) {
	      this._playheads.push(new SG.Playhead(data, this._playheads.length));
	      this._numPlayheads = this._playheads.length;
	      return this._playheads.length - 1;
	    },
	    play: function play() {
	      if (this._playing) return;
	      this._playing = true;
	      this._paused = false;
	      this.updatePauseAtTime();
	      this.loopPlay();
	    },
	    pause: function pause() {
	      this._playing = false;
	      this._paused = true;
	    },
	    stopPlayback: function stopPlayback() {
	      this._playing = this._paused = false;
	      this._currentTime = 0;
	      _.each(this._playheads, function (playhead) {
	        this.graph.removeMarker(playhead.uniqueId);
	      }, this);
	    },
	    maxDuration: function maxDuration() {
	      if (!this._maxDuration) {
	        this._maxDuration = _.reduce(this._playheads, function (memo, playhead) {
	          var diff = playhead.maxTime - playhead.firstTime;
	          return diff > memo ? diff : memo;
	        }, 0);
	      }
	      return this._maxDuration;
	    },
	    setPlaybackPercentage: function setPlaybackPercentage(pct) {
	      this._currentTime = Math.round(this.maxDuration() * pct / 100.0);
	      this.setTime(this._currentTime);
	    },
	    loopPlay: function loopPlay() {
	      if (!this._playing) return;
	      var time = this._currentTime + this.playbackSpeed,
	          allDone;
	      if (time > this.pauseAtTime) {
	        allDone = true;
	        time = this.pauseAtTime;
	      }
	      this._currentTime = time;
	      this.setTime(time);
	      if (allDone) {
	        this._playing = false;
	        $('#play_pause_btn').removeClass('playing');
	      } else {
	        setTimeout(this.loopPlay, 50);
	      }
	    },
	    pauseOnAnyFinish: function pauseOnAnyFinish(bool) {
	      this._pauseOnAnyFinish = bool;
	      this.updatePauseAtTime();
	    },
	    updatePauseAtTime: function updatePauseAtTime() {
	      if (this._pauseOnAnyFinish) {
	        this.pauseAtTime = _.reduce(this._playheads, function (memo, playhead) {
	          return playhead.duration > this._currentTime && (!memo || memo > playhead.duration) ? playhead.duration : memo;
	        }, null, this);
	      } else {
	        this.pauseAtTime = _.reduce(this._playheads, function (memo, playhead) {
	          return playhead.duration > this._currentTime && (!memo || memo < playhead.duration) ? playhead.duration : memo;
	        }, null, this);
	      }
	    },
	    setTime: function setTime(time) {
	      var playheads = this._playheads,
	          ptsAround,
	          largestReportedTime = 0;
	      for (var i = 0; i < this._numPlayheads; i++) {
	        ptsAround = playheads[i].pointsAroundOffsetTime(time);
	        var points = playheads[i].points(),
	            lastPt = points[ptsAround.lowI],
	            pt = points[ptsAround.highI],
	            timeFromPlayhead = ptsAround.x - playheads[i].firstTime;
	        if (timeFromPlayhead > largestReportedTime) largestReportedTime = timeFromPlayhead;
	
	        // positioning marker on map requires points with lat/lng
	        if (lastPt.point && pt.point) {
	          var lat1 = lastPt.point.lat,
	              lng1 = lastPt.point.lng,
	              lat2 = pt.point.lat,
	              lng2 = pt.point.lng,
	              newLat = (lat2 - lat1) * ptsAround.pct + lat1,
	              newLng = (lng2 - lng1) * ptsAround.pct + lng1;
	          this.graph.showMarker(newLng, newLat, playheads[i].uniqueId);
	        }
	      }
	      this.largestReportedTime = largestReportedTime;
	      var pct = Math.round(100 * largestReportedTime / this.maxDuration());
	      $("#elapsed_time_slider").slider('option', 'value', pct);
	      $('#elapsed_time').html(rwgps.LabelMaker.durationLabel(Math.floor(largestReportedTime)));
	    }
	  };
	})(SampleGraph);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	* Segment Selector widget
	*
	* Only required if the user will be defining segments
	*/
	
	(function (SG) {
	  SG.registerModule('segmentSelector');
	  SG.bind('initialize:after', function (graph) {
	    _.bindAll(graph, 'setDragBehaviorToZoomIn', 'setDragBehaviorToSelectSegment', 'selectSegmentFromZoom');
	    // dom bindings
	    $('.sg-on-drag-select-segment').live('click', graph.setDragBehaviorToSelectSegment);
	    $('.sg-select-segment').live('click', graph.selectSegmentFromZoom);
	  });
	  SG.bind('configure', function (graph) {
	    _.extend(graph.options, {
	      recenterOnSelectSegment: false,
	      revertToZoomInAfterSelectSegment: true
	    });
	  });
	  SG.bind('unload_bindings:before', function (graph) {
	    // unload our live handlers
	    $('.sg-on-drag-select-segment').die('click', graph.setDragBehaviorToSelectSegment);
	  });
	
	  _.extend(SG.prototype, {
	    setDragBehaviorToSelectSegment: function setDragBehaviorToSelectSegment(e) {
	      if (!e || !$(e.target).hasClass("selected")) {
	        this.segmentselectedBehavior = 'select_segment';
	        $('.sg-on-drag-zoom-in').removeClass('selected');
	        $('.sg-on-drag-select-segment').addClass('selected');
	        this.unbindFrom(this, 'segmentselected', this._currentDragBehaviorFn);
	        this._currentDragBehaviorFn = this.selectSegment;
	        this.bindTo(this, 'segmentselected', this._currentDragBehaviorFn);
	      }
	    },
	    selectSegmentFromZoom: function selectSegmentFromZoom() {
	      this.selectSegment(this.zoomedSlice(), true);
	    },
	    // the other option for drag behavior, aside from zoomToDataSlice
	    selectSegment: function selectSegment(dataSlice, recenterOn) {
	      // lock the user into zooming only while there is a selected segment in play
	      this.options._extendedSelectionOptions = this.options.extendedSelectionOptions;
	      this.options.extendedSelectionOptions = false;
	      this.setDragBehaviorToZoomIn();
	      if (this.options.revertToZoomInAfterSelectSegment) {
	        this.updateZoomingTip();
	      }
	
	      this.segmentSelector = new SG.SegmentSelector({ graph: this, dataSlice: dataSlice });
	      if (recenterOn || this.options.recenterOnSelectSegment) this.segmentSelector.reCenter();
	
	      var that = this;
	      this.bindTo(this, 'segmentselector:unload', function afterUnload() {
	        if (that.options.revertToZoomInAfterSelectSegment) that.options.extendedSelectionOptions = this.options._extendedSelectionOptions;
	        delete this.options._extendedSelectionOptions;
	        that.updateZoomingTip();
	        delete that.segmentSelector;
	        that.unbindFrom(that, 'segmentselector:unload', afterUnload);
	      });
	
	      this.trigger("segmentselector:load");
	    }
	  });
	
	  SG.SegmentSelector = Backbone.View.extend({
	    // expected options: graph, dataSlice
	    initialize: function initialize() {
	      var graph = this.graph = this.options.graph;
	      var dataSlice = this.dataSlice = this.options.dataSlice;
	      this.hidden = false;
	      _.bindAll(this, 'addControlBoundsTest', 'removeControlBoundsTest', 'reposition', 'beginDragResize', 'adjustResize', 'dragResizeMouseOut', 'cancelDragResize', 'completeDragResize', 'cacheLastSelected', 'reCenter', 'updateSelected', 'unload');
	      this.throttledUpdateSelected = _.throttle(this.updateSelected, 120);
	      var handleAWidth = 2,
	          handleBufferWidth = 5;
	      this.handleWidth = handleAWidth + handleBufferWidth;
	      this.$overlay = $('<div><div class="sg-handle sg-left"><div class="sg-buffer"></div><div class="sg-a"><div class="sg-handle-circle"></div></div></div><div class="sg-segment-selector-middle"></div><div class="sg-handle sg-right"><div class="sg-a"><div class="sg-handle-circle"></div></div><div class="sg-buffer"></div></div></div>').addClass('sg-segment-selector-control').css({ zIndex: graph.zIndex(5), position: 'absolute' }).offset({ top: graph.$canvas.offset().top + graph.plotMargin().top, left: 100 }).height(graph.plotHeight).mousedown(this.beginDragResize).appendTo(graph.$canvas.parent()).find('.sg-segment-selector-middle').height(graph.plotHeight).end().find('.sg-handle').width(this.handleWidth).height(graph.plotHeight).find('.sg-handle-circle').css({ zIndex: graph.zIndex(5), top: graph.plotHeight / 2 - 7 }).end().find('.sg-buffer').width(handleBufferWidth).height(graph.plotHeight).end().find('.sg-a').width(handleAWidth).height(graph.plotHeight).end().end();
	
	      this.selectSlice(dataSlice);
	      _.defer(_.bind(function () {
	        this.reposition();
	      }, this));
	      this.overlayBoundsTests = [graph.standardBoundsTestFn(this.$overlay.find('.sg-left'), 5), graph.standardBoundsTestFn(this.$overlay.find('.sg-right'), 5)];
	      // kill the metrics overlay
	      graph.defaultMouseOutCleanup();
	      this.addControlBoundsTest();
	      graph.bindTo(graph, 'render:after', this.reposition);
	      graph.bindTo(graph, 'dragselect:begin', this.removeControlBoundsTest);
	      graph.bindTo(graph, 'dragselect:end', this.addControlBoundsTest);
	      graph.bindTo(graph, 'dataslice:select', this.cacheLastSelected);
	      graph.disableMapHighlighting();
	    },
	    unload: function unload() {
	      var graph = this.graph;
	      //if(this.actions.saveSegment) this.actions.closeSaveForm();
	      this.removeControlBoundsTest();
	      graph.unbindFrom(graph, 'render:after', this.reposition);
	      graph.unbindFrom(graph, 'dragselect:begin', this.removeControlBoundsTest);
	      graph.unbindFrom(graph, 'dragselect:end', this.addControlBoundsTest);
	      graph.unbindFrom(graph, 'dataslice:select', this.cacheLastSelected);
	      graph.enableMapHighlighting();
	      this.$overlay.remove();
	      graph.zoomOut();
	      if (!graph.options.revertToZoomInAfterSelectSegment) graph.setDragBehaviorToSelectSegment();
	      graph.trigger('segmentselector:unload');
	    },
	    hide: function hide() {
	      this.hidden = true;
	    },
	    show: function show() {
	      this.hidden = false;
	    },
	    reCenter: function reCenter() {
	      this.graph.zoomToDataSlice(this.dataSlice.buffer(this.graph.xAxisType()));
	    },
	    // need to keep track of last selected data slice so we can easily prevent
	    // triggering the event again if indexes dont change
	    cacheLastSelected: function cacheLastSelected(dataSlice) {
	      this.lastSelectedDataSlice = dataSlice;
	    },
	    addControlBoundsTest: function addControlBoundsTest() {
	      _.each(this.overlayBoundsTests, function (overlayBoundsTest) {
	        this.graph.addControlBoundsTest(overlayBoundsTest);
	      }, this);
	    },
	    removeControlBoundsTest: function removeControlBoundsTest() {
	      _.each(this.overlayBoundsTests, function (overlayBoundsTest) {
	        this.graph.removeControlBoundsTest(overlayBoundsTest);
	      }, this);
	    },
	    reposition: function reposition() {
	      var data = this.dataSlice.data(),
	          graph = this.graph,
	          offset = graph.$canvas.offset(),
	          left = offset.left + Math.round(graph.plotToPixel(data[0][graph.xAxisType()])),
	          width = offset.left + Math.round(graph.plotToPixel(data[data.length - 1][graph.xAxisType()])) - left;
	      var plotLeft = graph.$canvas.offset().left + graph.plotMargin().left,
	          plotRight = plotLeft + graph.plotWidth;
	      if (left + width < plotLeft || left > plotRight || this.hidden) {
	        this.$overlay.hide();
	      } else {
	        this.$overlay.show();
	        if (left + width > plotRight) {
	          width = plotRight - left + 1;
	          this.$overlay.find('.sg-handle.sg-right').hide();
	          this.rightHidden = true;
	        } else if (left < plotLeft) {
	          width = left + width - plotLeft;
	          left = plotLeft + this.handleWidth;
	          this.$overlay.find('.sg-handle.sg-left').hide();
	          this.leftHidden = true;
	        } else {
	          this.$overlay.find('.sg-handle.sg-right').show();
	          this.$overlay.find('.sg-handle.sg-left').show();
	          this.rightHidden = false;
	          this.leftHidden = false;
	        }
	        this.$overlay.offset({ left: left - this.handleWidth,
	          top: offset.top + graph.plotMargin().top }).height(graph.plotHeight).find('.sg-segment-selector-middle').width(width).height(graph.plotHeight).end().find('.sg-handle,.sg-buffer,.sg-a').height(graph.plotHeight).end().find('.sg-handle-circle').css({ zIndex: graph.zIndex(5), top: graph.plotHeight / 2 - 7 });
	      }
	    },
	    beginDragResize: function beginDragResize(e) {
	      if (e.button !== 0) return;
	      var graph = this.graph;
	      graph.defaultMouseOutCleanup();
	      if (this.dragging) {
	        this.endDragResize();
	        return;
	      }
	      // unbind the default stuff
	      graph.unbindMouseInteractions();
	      // stop blocking mousemove events from firing
	      this.removeControlBoundsTest();
	
	      // cancel out any text selections
	      document.body.focus();
	      // prevent text selection in IE
	      document.onselectstart = function () {
	        return false;
	      };
	
	      // prevent stuff on the page from getting selected during drag
	      e.preventDefault();
	      // alright we're dragging, lets keep track of our state in here
	      this.dragging = {
	        startX: graph.eventToCanvasCoords(e).x,
	        initialOffset: this.$overlay.offset(),
	        initialWidth: this.$overlay.width()
	      };
	      // mode is just from left to right what we're dragging... 1=left, 2=middle, 3=right
	      if ($(e.target).closest('.sg-handle').hasClass('sg-left')) {
	        this.dragging.mode = 1;
	      } else if ($(e.target).closest('.sg-handle').hasClass('sg-right')) {
	        this.dragging.mode = 3;
	      } else {
	        // for simplicity if a side is hidden... we are just setting middle drags to resizes on the visible side
	        if (this.leftHidden) this.dragging.mode = 3;else if (this.rightHidden) this.dragging.mode = 1;else this.dragging.mode = 2;
	      }
	
	      graph.bindTo(graph, 'mousemove', this.adjustResize);
	      graph.bindTo(graph, 'mouseout', this.dragResizeMouseOut);
	      graph.bindTo(graph, 'verticalmouseout', this.cancelDragResize);
	      // have to bind it to body because calling preventDefault on this event prevents mouseup from being triggered by this canvas
	      graph.bindTo(graph.$body, 'mouseup', this.completeDragResize);
	    },
	    adjustResize: function adjustResize(x) {
	      var displacement = this.dragging.startX - x,
	          dragging = this.dragging,
	          middleWidth = dragging.initialWidth - this.handleWidth * 2,
	          graph = this.graph,
	          offset = this.graph.$canvas.offset(),
	          leftSide = graph.plotMargin().left + offset.left,
	          rightSide = leftSide + graph.plotWidth,
	          left = dragging.initialOffset.left - displacement;
	      if (dragging.mode == 1) {
	        // dragging left handle
	        if (middleWidth + displacement < 1) displacement = 1 - middleWidth;
	        middleWidth += displacement;
	        this.$overlay.offset({ left: left }).find('.sg-segment-selector-middle').width(middleWidth);
	      } else if (dragging.mode == 2) {
	        // dragging from middle
	        var width = this.$overlay.width();
	        left = dragging.initialOffset.left - displacement + this.handleWidth;
	        // bounds for left side
	        if (left < leftSide) {
	          left = leftSide;
	        }
	        // bounds for right side
	        else if (left + width - this.handleWidth * 2 > rightSide) {
	            left = rightSide - width + this.handleWidth * 2;
	          }
	        this.$overlay.offset({ left: left - this.handleWidth });
	      } else {
	        // right handle
	        if (middleWidth - displacement < 1) displacement = middleWidth - 1;
	        middleWidth -= displacement;
	        this.$overlay.find('.sg-segment-selector-middle').width(middleWidth);
	      }
	
	      var isZoomed = this.graph.zoomedIn();
	      var leftShouldSnap = !isZoomed && left === leftSide;
	      var rightShouldSnap = !isZoomed && left + middleWidth === rightSide;
	      // snap
	      if (leftShouldSnap && !this.leftSnapped) {
	        this.$overlay.find('.sg-handle.sg-left').addClass('sg-snapped');
	        this.leftSnapped = true;
	      }
	      if (rightShouldSnap && !this.rightSnapped) {
	        this.$overlay.find('.sg-handle.sg-right').addClass('sg-snapped');
	        this.rightSnapped = true;
	      }
	      // or unsnap
	      if (!leftShouldSnap && this.leftSnapped) {
	        this.$overlay.find('.sg-handle.sg-left').removeClass('sg-snapped');
	        this.leftSnapped = false;
	      }
	      if (!rightShouldSnap && this.rightSnapped) {
	        this.$overlay.find('.sg-handle.sg-right').removeClass('sg-snapped');
	        this.rightSnapped = false;
	      }
	
	      this.throttledUpdateSelected();
	    },
	    updateSelected: function updateSelected() {
	      if (!this.dragging) return; //since this is throttled it might be called when the drag is over
	      var lastSlice = this.lastSelectedDataSlice,
	          dataSlice = this.getUpdatedDataSlice();
	      if (!lastSlice || lastSlice.i != dataSlice.i || lastSlice.count != dataSlice.count) {
	        this.graph.trigger('dataslice:select', dataSlice, 'only_metrics');
	      }
	    },
	    getUpdatedDataSlice: function getUpdatedDataSlice() {
	      var graph = this.graph,
	          $canvasOffset = graph.$canvas.offset(),
	          firstX = this.$overlay.offset().left + this.handleWidth - $canvasOffset.left,
	          firstI = this.dragging.mode != 3 ? graph.canvasXToDataI(firstX).closestI : this.dataSlice.i,
	          lastI = this.dragging.mode == 1 ? this.dataSlice.lastI : this.graph.canvasXToDataI(firstX + this.$overlay.width() - this.handleWidth * 2).closestI;
	      // we need to select at least one point
	      if (lastI == firstI) {
	        if (firstI == 0) lastI++;else firstI--;
	      }
	      return graph.dataSlice(firstI, 1 + lastI - firstI);
	    },
	    // if the mouse is off to the left or right, snap the selection there
	    dragResizeMouseOut: function dragResizeMouseOut(e) {
	      var graph = this.graph,
	          dragging = this.dragging,
	          coords = graph.eventToCanvasCoords(e),
	          leftSide = graph.plotMargin().left,
	          rightSide = leftSide + graph.plotWidth,
	          adjustedX;
	      if (dragging.mode == 1 && coords.x <= leftSide) {
	        //to pin the selected area to the left, need to make some adjustments for the pos. of the mouse cursor relative to the handle
	        adjustedX = leftSide - (dragging.initialOffset.left + this.handleWidth - graph.canvasToPageCoords(dragging.startX));
	        this.adjustResize(adjustedX);
	      } else if (dragging.mode == 3 && coords.x >= rightSide) {
	        adjustedX = rightSide + graph.canvasToPageCoords(dragging.startX) - (dragging.initialOffset.left + dragging.initialWidth - this.handleWidth);
	        this.adjustResize(adjustedX);
	      }
	    },
	    endDragResize: function endDragResize() {
	      var graph = this.graph;
	      delete this.dragging;
	      // undo our text selection prevention for IE
	      document.onselectstart = null;
	      graph.bindMouseInteractions();
	      this.addControlBoundsTest();
	      graph.unbindFrom(graph, 'mousemove', this.adjustResize);
	      graph.unbindFrom(graph, 'mouseout', this.dragResizeMouseOut);
	      graph.unbindFrom(graph, 'verticalmouseout', this.cancelDragResize);
	      graph.unbindFrom(graph.$body, 'mouseup', this.completeDragSelect);
	    },
	    cancelDragResize: function cancelDragResize() {
	      this.endDragResize();
	      // reposition to where the overlay started
	      this.reposition();
	    },
	    selectSlice: function selectSlice(dataSlice) {
	      this.dataSlice = dataSlice;
	      this.reposition();
	      this.graph.trigger('dataslice:select', dataSlice, 'only_metrics');
	    },
	    completeDragResize: function completeDragResize(e) {
	      var endPosition = this.graph.eventToCanvasCoords(e),
	          startX = this.dragging.startX,
	          mode = this.dragging.mode,
	          displacement = endPosition.x - startX;
	
	      var dataSlice = this.getUpdatedDataSlice();
	      this.endDragResize();
	
	      // with a 1 pixel epsilon in the middle section of the selector, call this a pointselected event
	      if (Math.abs(displacement) <= 1 && mode === 2) {
	        var pointsAround = this.graph.canvasXToDataI(startX);
	        this.graph.unbindFrom(this.graph, 'pointselected', this.graph.zoomOutOnClick);
	        this.graph.trigger('pointselected', pointsAround);
	        this.graph.bindTo(this.graph, 'pointselected', this.graph.zoomOutOnClick);
	      } else {
	        this.selectSlice(dataSlice);
	      }
	    }
	  });
	})(SampleGraph);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	/* 
	* Add support for lazy loaded templates
	*
	*/
	
	(function (SG, window, $) {
	  SG.registerModule('templates');
	
	  _.extend(SG, {
	    _compiledTemplates: {},
	    // if the template isn't compiled, compile it
	    // id should correspond to the template's dom id
	    // renders the template with passed optional data
	    template: function template(id, data) {
	      var dict = this._compiledTemplates;
	      if (!dict[id]) {
	        dict[id] = _.template($('#' + id).html());
	      }
	      return dict[id](data);
	    }
	  });
	})(SampleGraph, window, jQuery);

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["SampleGraph"] = __webpack_require__(6);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// graph-d0404e8dff0b1b7fae12-bundle.js